import type { Journey } from './journeyData';

export const JOURNEYS_BATCH22: Journey[] = [
{
  id: 349,
  slug: 'botswana-okavango-delta-chobe-moremi-makgadikgadi',
  title: 'Botswana: Okavango Delta, Chobe, Moremi & Makgadikgadi',
  region: 'Africa',
  country: 'Botswana',
  cities: ['Maun', 'Okavango Delta', 'Moremi', 'Chobe', 'Makgadikgadi'],
  travelStyle: 'Wildlife Journey',
  wayToTravel: 'Wildlife Journeys',
  interests: ['Wildlife & Safari', 'Nature', 'Adventure'],
  months: ['June', 'July', 'August', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Private — 2 to 8 guests',
  activityLevel: 'Easy',
  price: 16500,
  priceLabel: 'From $16,500 pp',
  availability: 'Open',
  shortDescription: 'Botswana\'s ultimate safari — the Okavango Delta by mokoro, Moremi\'s wild dogs, Chobe\'s elephant herds, and Makgadikgadi\'s meerkats.',
  overview: 'Botswana is Africa\'s premier safari destination — a country that has chosen quality over quantity, with low-volume, high-value tourism that protects its extraordinary wildlife. The Okavango Delta is one of the world\'s great natural wonders — an inland delta that floods the Kalahari Desert. Chobe has the world\'s highest concentration of elephants. Makgadikgadi is one of the world\'s largest salt pans.',
  highlights: [
  'Okavango Delta — mokoro through papyrus channels',
  'Moremi — African wild dogs and leopards',
  'Chobe — elephant herds at the river',
  'Makgadikgadi — meerkats and zebra migration',
  'Helicopter over the Okavango Delta',
  'Walking safari — tracking wildlife on foot'],

  itinerary: ['Maun', 'Okavango Delta', 'Moremi', 'Chobe', 'Makgadikgadi'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Maun & Okavango', description: 'Day 1: Arrive Maun. Fly to Okavango Delta. Afternoon mokoro. Day 2: Morning game walk. Helicopter over the delta.', accommodation: 'Mombo Camp', meals: 'All meals' },
  { day: 'Days 3–4', title: 'Moremi', description: 'Day 3: Fly to Moremi. Game drives — wild dogs, lion, leopard. Day 4: Full day game drives. Night drive.', accommodation: 'Xakanaxa Camp', meals: 'All meals' },
  { day: 'Days 5–7', title: 'Chobe', description: 'Day 5: Fly to Chobe. River cruise — elephant herds. Day 6: Game drives — buffalo, lion. Day 7: Boat safari at sunset.', accommodation: 'Chobe Chilwero', meals: 'All meals' },
  { day: 'Days 8–10', title: 'Makgadikgadi', description: 'Day 8: Fly to Makgadikgadi. Meerkat habituation. Day 9: Zebra migration (seasonal). Quad biking on the salt pans. Day 10: Fly Maun. Depart.', accommodation: 'Jack\'s Camp', meals: 'All meals' }],

  accommodation: 'Mombo Camp (Okavango); Xakanaxa Camp (Moremi); Chobe Chilwero; Jack\'s Camp (Makgadikgadi).',
  included: ['All accommodation', 'All meals', 'Expert guide', 'All game drives', 'Mokoro', 'Helicopter flight', 'Walking safari', 'All park fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Maun', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Maun; light aircraft between camps; mokoro; private 4WD.',
  meals: 'All meals throughout.',
  packing: ['Neutral safari clothing', 'Warm layers for early mornings', 'Binoculars', 'Camera', 'Sunscreen', 'Insect repellent', 'Soft-sided luggage'],
  visa: 'Botswana visa-free for most nationalities (90 days).',
  weather: 'June–October: dry season — best game viewing. Delta floods May–August.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What is a mokoro?', answer: 'A mokoro is a traditional dugout canoe poled silently through the Okavango\'s papyrus channels. It offers an intimate, silent wildlife experience at water level.' },
  { question: 'Are wild dogs common in Moremi?', answer: 'Moremi has one of Africa\'s highest wild dog densities. Sightings are excellent, especially in the dry season when packs are denning.' }],

  seo: {
    title: 'Botswana Okavango Delta Chobe Moremi Makgadikgadi | Worldway × A&K',
    description: 'Botswana\'s ultimate safari — Okavango Delta, Chobe elephants, and Makgadikgadi meerkats with Worldway × A&K.',
    keywords: ['Botswana safari', 'Okavango Delta', 'Chobe', 'Moremi', 'Makgadikgadi', 'wild dogs'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1e100d6d1-1765658101194.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80',
  'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80'],

  relatedJourneys: ['zimbabwe-victoria-falls-hwange-mana-pools', 'zambia-south-luangwa-lower-zambezi-walking'],
  aiIndex: { tags: ['Botswana', 'Okavango Delta', 'Chobe', 'Moremi', 'Makgadikgadi', 'wild dogs', 'mokoro'], searchable: true }
},
{
  id: 350,
  slug: 'italy-rome-florence-venice-amalfi-sicily',
  title: 'Italy: Rome, Florence, Venice, Amalfi & Sicily',
  region: 'Europe',
  country: 'Italy',
  cities: ['Rome', 'Florence', 'Venice', 'Amalfi Coast', 'Sicily'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Culinary', 'History'],
  months: ['April', 'May', 'June', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 16,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 9800,
  priceLabel: 'From $9,800 pp',
  availability: 'Open',
  shortDescription: 'Italy\'s grand tour — the Colosseum, Uffizi Gallery, Venice\'s canals, Amalfi\'s clifftop villages, and Sicily\'s Greek temples.',
  overview: 'Italy is the world\'s greatest cultural destination — a country of extraordinary art, architecture, cuisine, and history. Rome is the Eternal City. Florence is the cradle of the Renaissance. Venice is the world\'s most romantic city. The Amalfi Coast is one of Europe\'s most dramatic coastlines. Sicily is a crossroads of civilisations with Greek temples, Norman cathedrals, and Arab-Norman architecture.',
  highlights: [
  'Rome — Colosseum, Vatican, and Sistine Chapel',
  'Florence — Uffizi Gallery and Michelangelo\'s David',
  'Venice — gondola on the Grand Canal',
  'Amalfi Coast — Positano and Ravello',
  'Sicily — Valley of the Temples, Agrigento',
  'Italian cooking class — pasta and tiramisu'],

  itinerary: ['Rome', 'Florence', 'Venice', 'Amalfi Coast', 'Sicily'],
  itineraryDays: [
  { day: 'Days 1–4', title: 'Rome', description: 'Day 1: Arrive Rome. Trastevere. Welcome dinner. Day 2: Colosseum, Roman Forum, Palatine Hill. Day 3: Vatican — Sistine Chapel, St. Peter\'s. Day 4: Borghese Gallery, Trevi Fountain.', accommodation: 'Hotel de Russie', meals: 'Breakfast daily' },
  { day: 'Days 5–7', title: 'Florence', description: 'Day 5: Train to Florence. Uffizi Gallery. Day 6: Michelangelo\'s David, Duomo. Day 7: Cooking class. Chianti wine tasting.', accommodation: 'Portrait Firenze', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'Venice', description: 'Day 8: Train to Venice. Gondola on the Grand Canal. Day 9: St. Mark\'s Basilica, Doge\'s Palace. Day 10: Murano glass, Burano lace. Fly to Naples.', accommodation: 'Aman Venice', meals: 'Breakfast daily' },
  { day: 'Days 11–13', title: 'Amalfi Coast', description: 'Day 11: Arrive Amalfi. Positano. Day 12: Ravello — Villa Cimbrone gardens. Day 13: Boat trip along the coast. Fly to Palermo.', accommodation: 'Belmond Hotel Caruso', meals: 'Breakfast daily' },
  { day: 'Days 14–16', title: 'Sicily', description: 'Day 14: Arrive Palermo. Arab-Norman Cathedral. Day 15: Valley of the Temples, Agrigento. Day 16: Mount Etna. Fly Rome. Depart.', accommodation: 'Verdura Resort', meals: 'Breakfast daily' }],

  accommodation: 'Hotel de Russie (Rome); Portrait Firenze; Aman Venice; Belmond Hotel Caruso (Amalfi); Verdura Resort (Sicily).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'All entrance fees', 'Cooking class', 'Gondola', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Rome', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Rome; high-speed trains; domestic flights; private coach.',
  meals: 'Daily breakfast; cooking class lunch.',
  packing: ['Smart casual clothing', 'Comfortable walking shoes', 'Modest clothing for churches', 'Sunscreen', 'Camera'],
  visa: 'Italy is Schengen — EU/EEA visa-free. Others check requirements.',
  weather: 'April–June and September–October: 20–28°C — ideal.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Do we need to book the Vatican in advance?', answer: 'Yes — Vatican tickets must be booked months in advance. We handle all bookings including skip-the-line access to the Sistine Chapel.' },
  { question: 'Is Venice sinking?', answer: 'Venice is slowly subsiding, but the city is investing heavily in flood barriers (MOSE). It remains one of the world\'s most extraordinary cities.' }],

  seo: {
    title: 'Italy Rome Florence Venice Amalfi Sicily | Worldway × A&K',
    description: 'Italy\'s grand tour — Rome, Florence, Venice, Amalfi Coast, and Sicily with Worldway × A&K.',
    keywords: ['Italy tour', 'Rome', 'Florence', 'Venice', 'Amalfi Coast', 'Sicily', 'grand tour'],
    ogImage: "https://images.unsplash.com/photo-1588758330825-a93d37d60690"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['greece-athens-santorini-mykonos-crete-rhodes', 'france-paris-loire-valley-provence-bordeaux'],
  aiIndex: { tags: ['Italy', 'Rome', 'Florence', 'Venice', 'Amalfi Coast', 'Sicily', 'grand tour', 'cultural'], searchable: true }
},
{
  id: 351,
  slug: 'galapagos-islands-expedition-cruise-wildlife',
  title: 'Galápagos Islands: Expedition Cruise & Wildlife',
  region: 'Latin America',
  country: 'Ecuador',
  cities: ['Quito', 'Galápagos Islands', 'Santa Cruz', 'Isabela', 'Fernandina'],
  travelStyle: 'Expedition Journey',
  wayToTravel: 'Expedition Journeys',
  interests: ['Wildlife & Safari', 'Adventure', 'Nature'],
  months: ['January', 'February', 'March', 'April', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Small Group — maximum 16 guests',
  activityLevel: 'Moderate',
  price: 12500,
  priceLabel: 'From $12,500 pp',
  availability: 'Open',
  shortDescription: 'The Galápagos Islands — Darwin\'s living laboratory — giant tortoises, marine iguanas, blue-footed boobies, and swimming with sea lions.',
  overview: 'The Galápagos Islands are one of the world\'s most extraordinary wildlife destinations — the living laboratory that inspired Charles Darwin\'s theory of evolution. The islands\' wildlife has no fear of humans, allowing extraordinary close encounters. Giant tortoises, marine iguanas, blue-footed boobies, flightless cormorants, and Galápagos penguins are found nowhere else on Earth.',
  highlights: [
  'Giant tortoises — the world\'s largest tortoise',
  'Marine iguanas — the world\'s only sea-going lizard',
  'Blue-footed boobies — mating dance display',
  'Swimming with sea lions and marine turtles',
  'Flightless cormorants — unique to Fernandina',
  'Darwin\'s finches — evolution in action'],

  itinerary: ['Quito', 'Santa Cruz', 'Isabela', 'Fernandina', 'Española'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Quito', description: 'Day 1: Arrive Quito. UNESCO old town. Welcome dinner. Day 2: Mitad del Mundo — equator monument. Fly to Galápagos.', accommodation: 'Casa Gangotena', meals: 'Breakfast daily' },
  { day: 'Days 3–10', title: 'Galápagos Expedition', description: 'Day 3: Santa Cruz — Charles Darwin Research Station, giant tortoises. Day 4: Isabela — marine iguanas, penguins. Day 5: Fernandina — flightless cormorants. Day 6: Española — blue-footed boobies, waved albatross. Day 7: Genovesa — red-footed boobies. Day 8: San Cristóbal — sea lions. Day 9: Snorkelling with hammerhead sharks. Day 10: Final island visit.', accommodation: 'Silver Galapagos Expedition Cruise', meals: 'All meals' },
  { day: 'Days 11–12', title: 'Return', description: 'Day 11: Fly to Quito. Day 12: Depart Quito.', accommodation: 'Casa Gangotena', meals: 'Breakfast daily' }],

  accommodation: 'Casa Gangotena (Quito); Silver Galapagos Expedition Cruise.',
  included: ['All accommodation', 'All meals on cruise', 'Daily breakfast', 'Expert naturalist guide', 'All snorkelling equipment', 'All park fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Quito', 'Travel insurance', 'Gratuities', 'Personal expenses', 'Galápagos entry fee'],
  transport: 'International flight to Quito; domestic flight to Galápagos; expedition cruise.',
  meals: 'All meals on cruise; breakfast daily elsewhere.',
  packing: ['Lightweight clothing', 'Waterproof jacket', 'Swimwear', 'Snorkelling gear (provided)', 'Sunscreen (reef-safe)', 'Camera with underwater housing', 'Binoculars'],
  visa: 'Ecuador visa-free for most nationalities. Galápagos entry fee required.',
  weather: 'Year-round destination. Jan–May: warm and calm. Jun–Dec: cooler with upwellings.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Are the animals really unafraid of humans?', answer: 'Yes — Galápagos wildlife has evolved without natural predators and shows no fear of humans. Sea lions will approach you on the beach and swim alongside you.' },
  { question: 'Is the cruise comfortable?', answer: 'The Silver Galapagos is a luxury expedition vessel with spacious cabins, excellent cuisine, and expert naturalist guides. Motion sickness medication is recommended.' }],

  seo: {
    title: 'Galápagos Islands Expedition Cruise Wildlife | Worldway × A&K',
    description: 'Galápagos Islands expedition — giant tortoises, marine iguanas, and blue-footed boobies with Worldway × A&K.',
    keywords: ['Galápagos tour', 'expedition cruise', 'giant tortoises', 'marine iguanas', 'blue-footed boobies', 'Darwin'],
    ogImage: "https://images.unsplash.com/photo-1640096038393-3019d3b5a730"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80',
  'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80'],

  relatedJourneys: ['costa-rica-cloud-forest-arenal-tortuguero-osa', 'brazil-amazon-pantanal-iguazu-rio-carnival'],
  aiIndex: { tags: ['Galápagos', 'expedition cruise', 'giant tortoises', 'marine iguanas', 'blue-footed boobies', 'Darwin', 'wildlife'], searchable: true }
},
{
  id: 352,
  slug: 'spain-andalucia-seville-granada-cordoba-ronda',
  title: 'Spain: Andalucía — Seville, Granada, Córdoba & Ronda',
  region: 'Europe',
  country: 'Spain',
  cities: ['Seville', 'Granada', 'Córdoba', 'Ronda', 'Marbella'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Culinary', 'History'],
  months: ['March', 'April', 'May', 'September', 'October', 'November'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 6200,
  priceLabel: 'From $6,200 pp',
  availability: 'Open',
  shortDescription: 'Andalucía\'s Moorish splendour — Seville\'s flamenco, Granada\'s Alhambra, Córdoba\'s Mezquita, and Ronda\'s dramatic gorge.',
  overview: 'Andalucía is Spain\'s most captivating region — a land of Moorish palaces, flamenco passion, sherry bodegas, and whitewashed villages. The Alhambra in Granada is one of the world\'s most beautiful buildings. Seville\'s Cathedral is the world\'s largest Gothic church. Córdoba\'s Mezquita is one of the world\'s greatest examples of Islamic architecture.',
  highlights: [
  'Alhambra — the world\'s most beautiful Moorish palace',
  'Seville — flamenco show and tapas tour',
  'Córdoba — Mezquita and Jewish Quarter',
  'Ronda — dramatic gorge and bullring',
  'Sherry tasting — Jerez de la Frontera',
  'White villages — Arcos de la Frontera and Zahara'],

  itinerary: ['Seville', 'Jerez', 'Ronda', 'Córdoba', 'Granada'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Seville', description: 'Day 1: Arrive Seville. Tapas tour. Welcome dinner. Day 2: Cathedral, Alcázar, Barrio Santa Cruz. Day 3: Flamenco show. Jerez sherry bodega.', accommodation: 'Hotel Alfonso XIII', meals: 'Breakfast daily' },
  { day: 'Days 4–5', title: 'Ronda & White Villages', description: 'Day 4: Drive to Ronda. El Tajo gorge. Bullring. Day 5: White villages — Arcos, Zahara. Drive to Córdoba.', accommodation: 'Parador de Ronda', meals: 'Breakfast daily' },
  { day: 'Days 6–7', title: 'Córdoba', description: 'Day 6: Mezquita — the Great Mosque. Jewish Quarter. Day 7: Medina Azahara — Moorish palace ruins. Drive to Granada.', accommodation: 'Hospes Palacio del Bailío', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'Granada', description: 'Day 8: Alhambra — Nasrid Palaces, Generalife gardens. Day 9: Albaicín — Moorish quarter. Sacromonte caves. Day 10: Fly Madrid. Depart.', accommodation: 'Alhambra Palace Hotel', meals: 'Breakfast daily' }],

  accommodation: 'Hotel Alfonso XIII (Seville); Parador de Ronda; Hospes Palacio del Bailío (Córdoba); Alhambra Palace Hotel (Granada).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Alhambra tickets', 'Flamenco show', 'Sherry tasting', 'All entrance fees', 'All transfers'],
  excluded: ['International flights to Seville', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Seville; private coach.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Smart casual clothing', 'Comfortable walking shoes', 'Sunscreen', 'Camera', 'Light jacket for evenings'],
  visa: 'Spain is Schengen — EU/EEA visa-free. Others check requirements.',
  weather: 'March–May and September–November: 20–28°C — ideal. July–August: very hot.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Do Alhambra tickets need to be booked in advance?', answer: 'Yes — Alhambra tickets sell out months in advance. We book all tickets as part of the journey package.' },
  { question: 'What is the best flamenco show in Seville?', answer: 'Seville has many excellent tablaos. We recommend intimate venues in the Barrio Santa Cruz for the most authentic experience.' }],

  seo: {
    title: 'Spain Andalucía Seville Granada Córdoba Ronda | Worldway × A&K',
    description: 'Andalucía\'s Moorish splendour — Alhambra, Seville flamenco, and Córdoba Mezquita with Worldway × A&K.',
    keywords: ['Spain tour', 'Andalucía', 'Alhambra', 'Seville', 'Granada', 'Córdoba', 'flamenco'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_118977f85-1785742656937.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['portugal-lisbon-douro-valley-alentejo-algarve', 'morocco-imperial-cities-sahara-atlas-fes'],
  aiIndex: { tags: ['Spain', 'Andalucía', 'Alhambra', 'Seville', 'Granada', 'Córdoba', 'flamenco', 'cultural'], searchable: true }
},
{
  id: 353,
  slug: 'myanmar-bagan-inle-lake-mandalay-yangon',
  title: 'Myanmar: Bagan, Inle Lake, Mandalay & Yangon',
  region: 'Asia',
  country: 'Myanmar',
  cities: ['Yangon', 'Bagan', 'Inle Lake', 'Mandalay'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'History', 'Spiritual'],
  months: ['November', 'December', 'January', 'February', 'March'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 5800,
  priceLabel: 'From $5,800 pp',
  availability: 'Open',
  shortDescription: 'Myanmar\'s ancient wonders — Bagan\'s 2,000 temples, Inle Lake\'s floating villages, Mandalay\'s royal palace, and Yangon\'s Shwedagon Pagoda.',
  overview: 'Myanmar is one of Southeast Asia\'s most extraordinary destinations — a country of ancient temples, golden pagodas, and timeless traditions. Bagan is one of the world\'s greatest archaeological sites — a plain of over 2,000 Buddhist temples. Inle Lake is a unique ecosystem of floating gardens and leg-rowing fishermen. Mandalay is the last royal capital of Burma.',
  highlights: [
  'Bagan — hot air balloon over 2,000 temples at sunrise',
  'Shwedagon Pagoda — Yangon\'s golden stupa',
  'Inle Lake — leg-rowing fishermen and floating gardens',
  'Mandalay — Amarapura\'s U Bein Bridge at sunset',
  'Kyaiktiyo — the Golden Rock balancing pagoda',
  'Lacquerware workshop — traditional Burmese craft'],

  itinerary: ['Yangon', 'Bagan', 'Inle Lake', 'Mandalay'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Yangon', description: 'Day 1: Arrive Yangon. Shwedagon Pagoda at sunset. Welcome dinner. Day 2: Sule Pagoda, Bogyoke Market, colonial architecture. Fly to Bagan.', accommodation: 'Belmond Governor\'s Residence', meals: 'Breakfast daily' },
  { day: 'Days 3–5', title: 'Bagan', description: 'Day 3: Arrive Bagan. Afternoon temple exploration by e-bike. Day 4: Hot air balloon at sunrise over the temples. Day 5: Ananda Temple, Dhammayangyi. Lacquerware workshop.', accommodation: 'Bagan Lodge', meals: 'Breakfast daily' },
  { day: 'Days 6–8', title: 'Inle Lake', description: 'Day 6: Fly to Heho. Boat on Inle Lake. Day 7: Floating gardens, Phaung Daw Oo Pagoda, leg-rowing fishermen. Day 8: Indein ruins. Weaving workshop.', accommodation: 'Inle Princess Resort', meals: 'Breakfast daily' },
  { day: 'Days 9–12', title: 'Mandalay', description: 'Day 9: Fly to Mandalay. Mandalay Hill. Day 10: Amarapura — U Bein Bridge. Sagaing Hill. Day 11: Mingun — unfinished pagoda. Day 12: Fly Yangon. Depart.', accommodation: 'Rupar Mandalar Resort', meals: 'Breakfast daily' }],

  accommodation: 'Belmond Governor\'s Residence (Yangon); Bagan Lodge; Inle Princess Resort; Rupar Mandalar Resort (Mandalay).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Hot air balloon', 'All entrance fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Yangon', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Yangon; domestic flights; private boat; private coach.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Lightweight clothing', 'Modest clothing for pagodas (shoulders and knees covered)', 'Comfortable walking shoes', 'Sunscreen', 'Camera'],
  visa: 'Myanmar e-visa available online for most nationalities.',
  weather: 'November–March: dry season — 25–35°C. April–October: monsoon.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is the hot air balloon over Bagan worth it?', answer: 'The balloon flight over Bagan at sunrise is one of the world\'s most spectacular experiences — 2,000 temples stretching to the horizon in the golden morning light.' },
  { question: 'What is leg-rowing?', answer: 'Inle Lake fishermen balance on one leg on the stern of their boats and row with the other leg wrapped around the oar — a unique technique that frees both hands for fishing.' }],

  seo: {
    title: 'Myanmar Bagan Inle Lake Mandalay Yangon | Worldway × A&K',
    description: 'Myanmar\'s ancient wonders — Bagan temples, Inle Lake, and Mandalay with Worldway × A&K.',
    keywords: ['Myanmar tour', 'Bagan', 'Inle Lake', 'Mandalay', 'Yangon', 'temples', 'pagodas'],
    ogImage: "https://images.unsplash.com/photo-1708527731866-bd97d63c0e8e"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['thailand-bangkok-chiang-mai-elephant-sanctuary-islands', 'cambodia-angkor-phnom-penh-siem-reap-mekong'],
  aiIndex: { tags: ['Myanmar', 'Bagan', 'Inle Lake', 'Mandalay', 'Yangon', 'temples', 'pagodas', 'cultural'], searchable: true }
},
{
  id: 354,
  slug: 'france-paris-loire-valley-provence-bordeaux',
  title: 'France: Paris, Loire Valley, Provence & Bordeaux',
  region: 'Europe',
  country: 'France',
  cities: ['Paris', 'Loire Valley', 'Provence', 'Bordeaux'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Culinary', 'History'],
  months: ['April', 'May', 'June', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 14,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 8500,
  priceLabel: 'From $8,500 pp',
  availability: 'Open',
  shortDescription: 'France\'s finest journey — Paris\'s Louvre and Eiffel Tower, Loire Valley châteaux, Provence\'s lavender fields, and Bordeaux\'s grand crus.',
  overview: 'France is the world\'s most visited country — a nation of extraordinary art, architecture, cuisine, and wine. Paris is the world\'s most romantic city. The Loire Valley is a UNESCO World Heritage Site of Renaissance châteaux. Provence\'s lavender fields and Roman monuments are among Europe\'s most beautiful landscapes. Bordeaux is the world\'s wine capital.',
  highlights: [
  'Paris — Louvre, Eiffel Tower, and Montmartre',
  'Loire Valley — Château de Chambord and Chenonceau',
  'Provence — lavender fields and Roman Pont du Gard',
  'Bordeaux — grand cru wine tasting at Château Margaux',
  'Mont Saint-Michel — tidal island abbey',
  'French cooking class — coq au vin and crème brûlée'],

  itinerary: ['Paris', 'Loire Valley', 'Provence', 'Bordeaux'],
  itineraryDays: [
  { day: 'Days 1–4', title: 'Paris', description: 'Day 1: Arrive Paris. Montmartre. Welcome dinner. Day 2: Louvre, Musée d\'Orsay. Day 3: Eiffel Tower, Champs-Élysées, Versailles. Day 4: Marais, Sainte-Chapelle. Train to Loire Valley.', accommodation: 'Le Meurice', meals: 'Breakfast daily' },
  { day: 'Days 5–7', title: 'Loire Valley', description: 'Day 5: Château de Chambord. Day 6: Château de Chenonceau. Day 7: Amboise — Leonardo da Vinci\'s home. Drive to Provence.', accommodation: 'Château de Pray', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'Provence', description: 'Day 8: Arrive Provence. Lavender fields (June–July). Day 9: Pont du Gard, Nîmes. Day 10: Les Baux-de-Provence. Cooking class.', accommodation: 'Baumanière Les Baux-de-Provence', meals: 'Breakfast daily' },
  { day: 'Days 11–14', title: 'Bordeaux', description: 'Day 11: Drive to Bordeaux. Cité du Vin. Day 12: Château Margaux — grand cru tasting. Day 13: Saint-Émilion — UNESCO wine village. Day 14: Fly Paris. Depart.', accommodation: 'InterContinental Bordeaux', meals: 'Breakfast daily' }],

  accommodation: 'Le Meurice (Paris); Château de Pray (Loire); Baumanière Les Baux (Provence); InterContinental Bordeaux.',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Cooking class', 'Wine tastings', 'All entrance fees', 'All transfers'],
  excluded: ['International flights to Paris', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Paris; TGV high-speed trains; private coach.',
  meals: 'Daily breakfast; cooking class lunch.',
  packing: ['Smart casual clothing', 'Comfortable walking shoes', 'Sunscreen', 'Camera', 'Light jacket for evenings'],
  visa: 'France is Schengen — EU/EEA visa-free. Others check requirements.',
  weather: 'April–June and September–October: 18–25°C — ideal.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'When do the lavender fields bloom in Provence?', answer: 'Lavender blooms from late June to early August — peak is usually mid-July. The Valensole Plateau and Luberon are the most spectacular locations.' },
  { question: 'Can we visit Château Margaux?', answer: 'Yes — we arrange exclusive visits to Château Margaux and other premier cru estates. Advance booking is essential.' }],

  seo: {
    title: 'France Paris Loire Valley Provence Bordeaux | Worldway × A&K',
    description: 'France\'s finest journey — Paris, Loire châteaux, Provence lavender, and Bordeaux wine with Worldway × A&K.',
    keywords: ['France tour', 'Paris', 'Loire Valley', 'Provence', 'Bordeaux', 'wine', 'châteaux'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1191f077e-1785751015067.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['italy-rome-florence-venice-amalfi-sicily', 'spain-andalucia-seville-granada-cordoba-ronda'],
  aiIndex: { tags: ['France', 'Paris', 'Loire Valley', 'Provence', 'Bordeaux', 'wine', 'châteaux', 'cultural'], searchable: true }
},
{
  id: 355,
  slug: 'rwanda-gorilla-trekking-volcanoes-nyungwe-akagera',
  title: 'Rwanda: Gorilla Trekking, Volcanoes, Nyungwe & Akagera',
  region: 'Africa',
  country: 'Rwanda',
  cities: ['Kigali', 'Volcanoes National Park', 'Nyungwe Forest', 'Akagera'],
  travelStyle: 'Wildlife Journey',
  wayToTravel: 'Wildlife Journeys',
  interests: ['Wildlife & Safari', 'Conservation', 'Adventure'],
  months: ['June', 'July', 'August', 'September', 'December', 'January', 'February'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 8 guests',
  activityLevel: 'Moderate',
  price: 14500,
  priceLabel: 'From $14,500 pp',
  availability: 'Open',
  shortDescription: 'Rwanda — the Land of a Thousand Hills — mountain gorilla trekking, chimpanzee tracking in Nyungwe, and Big Five safari in Akagera.',
  overview: 'Rwanda is Africa\'s most remarkable conservation success story — a country that has transformed from tragedy to triumph in just three decades. Mountain gorilla trekking in Volcanoes National Park is one of the world\'s most extraordinary wildlife experiences. Nyungwe Forest is one of Africa\'s oldest rainforests and home to chimpanzees and 13 primate species. Akagera has been restored to full Big Five status.',
  highlights: [
  'Mountain gorillas — one hour with a gorilla family',
  'Golden monkeys — playful primates in bamboo forest',
  'Chimpanzee tracking in Nyungwe Forest',
  'Akagera — Big Five including recently reintroduced rhino',
  'Kigali Genocide Memorial — deeply moving',
  'Canopy walk — Nyungwe\'s 200m suspension bridge'],

  itinerary: ['Kigali', 'Volcanoes', 'Nyungwe', 'Akagera'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Kigali', description: 'Day 1: Arrive Kigali. Genocide Memorial. Welcome dinner. Day 2: Kigali city tour. Drive to Volcanoes.', accommodation: 'Kigali Serena Hotel', meals: 'Breakfast daily' },
  { day: 'Days 3–5', title: 'Volcanoes National Park', description: 'Day 3: Gorilla trekking permit briefing. Afternoon golden monkey trek. Day 4: Mountain gorilla trekking — one hour with a family. Day 5: Second gorilla trek (optional). Drive to Nyungwe.', accommodation: 'Bisate Lodge', meals: 'All meals' },
  { day: 'Days 6–7', title: 'Nyungwe Forest', description: 'Day 6: Chimpanzee tracking. Day 7: Canopy walk — 200m suspension bridge. Colobus monkeys.', accommodation: 'One&Only Nyungwe House', meals: 'All meals' },
  { day: 'Days 8–10', title: 'Akagera National Park', description: 'Day 8: Drive to Akagera. Afternoon game drive. Day 9: Full day game drives — lion, elephant, rhino, hippo. Day 10: Morning drive. Fly Kigali. Depart.', accommodation: 'Magashi Camp', meals: 'All meals' }],

  accommodation: 'Kigali Serena Hotel; Bisate Lodge (Volcanoes); One&Only Nyungwe House; Magashi Camp (Akagera).',
  included: ['All accommodation', 'All meals at lodges', 'Daily breakfast', 'Expert guide', 'Gorilla trekking permit', 'Chimpanzee tracking', 'All park fees', 'All transfers'],
  excluded: ['International flights to Kigali', 'Travel insurance', 'Gratuities', 'Personal expenses', 'Optional second gorilla trek'],
  transport: 'International flight to Kigali; private 4WD.',
  meals: 'All meals at lodges; breakfast daily elsewhere.',
  packing: ['Sturdy hiking boots', 'Waterproof jacket', 'Long trousers and sleeves', 'Gardening gloves (for nettles)', 'Insect repellent', 'Camera'],
  visa: 'Rwanda e-visa available online. Gorilla permit required (included).',
  weather: 'June–September and December–February: dry seasons — best for trekking.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'How difficult is gorilla trekking?', answer: 'Treks range from 1–8 hours depending on gorilla family location. The terrain is steep and muddy. Good fitness is required. Porters are available to carry bags.' },
  { question: 'How many gorillas are left in the wild?', answer: 'There are approximately 1,063 mountain gorillas remaining in the wild — all in the Virunga Massif (Rwanda, Uganda, DRC) and Bwindi (Uganda). Numbers are slowly increasing.' }],

  seo: {
    title: 'Rwanda Gorilla Trekking Volcanoes Nyungwe Akagera | Worldway × A&K',
    description: 'Rwanda — mountain gorilla trekking, Nyungwe chimpanzees, and Akagera Big Five with Worldway × A&K.',
    keywords: ['Rwanda tour', 'gorilla trekking', 'Volcanoes National Park', 'Nyungwe', 'Akagera', 'mountain gorillas'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_106f64fe4-1773816784955.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80',
  'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80'],

  relatedJourneys: ['uganda-bwindi-gorilla-trekking-queen-elizabeth', 'kenya-masai-mara-amboseli-laikipia-private'],
  aiIndex: { tags: ['Rwanda', 'gorilla trekking', 'Volcanoes', 'Nyungwe', 'Akagera', 'mountain gorillas', 'conservation'], searchable: true }
},
{
  id: 356,
  slug: 'jordan-petra-wadi-rum-dead-sea-aqaba',
  title: 'Jordan: Petra, Wadi Rum, Dead Sea & Aqaba',
  region: 'Middle East',
  country: 'Jordan',
  cities: ['Amman', 'Petra', 'Wadi Rum', 'Dead Sea', 'Aqaba'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'History', 'Adventure'],
  months: ['March', 'April', 'May', 'September', 'October', 'November'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Moderate',
  price: 5500,
  priceLabel: 'From $5,500 pp',
  availability: 'Open',
  shortDescription: 'Jordan\'s extraordinary heritage — Petra\'s rose-red city, Wadi Rum\'s desert camp, the Dead Sea, and Aqaba\'s Red Sea diving.',
  overview: 'Jordan is one of the Middle East\'s most welcoming and historically rich destinations. Petra is one of the world\'s greatest archaeological sites — a Nabataean city of rose-red rock-cut tombs. Wadi Rum is a vast desert of sandstone mountains and ancient rock art. The Dead Sea is the world\'s lowest point and saltiest body of water. Aqaba offers world-class Red Sea diving.',
  highlights: [
  'Petra — the Treasury (Al-Khazneh) at dawn',
  'Petra by Night — candlelit Treasury',
  'Wadi Rum — camel trek and overnight Bedouin camp',
  'Dead Sea — floating in the world\'s saltiest water',
  'Jerash — the best-preserved Roman city outside Italy',
  'Aqaba — Red Sea diving and snorkelling'],

  itinerary: ['Amman', 'Jerash', 'Petra', 'Wadi Rum', 'Dead Sea', 'Aqaba'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Amman & Jerash', description: 'Day 1: Arrive Amman. Citadel. Welcome dinner. Day 2: Jerash — Roman colonnaded street, temples, theatre. Drive to Petra.', accommodation: 'Four Seasons Hotel Amman', meals: 'Breakfast daily' },
  { day: 'Days 3–5', title: 'Petra', description: 'Day 3: Arrive Petra. Siq walk to the Treasury. Day 4: Petra by Night. Monastery (Ad Deir). Day 5: Little Petra. Drive to Wadi Rum.', accommodation: 'Mövenpick Resort Petra', meals: 'Breakfast daily' },
  { day: 'Days 6–7', title: 'Wadi Rum', description: 'Day 6: Arrive Wadi Rum. Jeep tour — Lawrence of Arabia locations. Day 7: Camel trek. Overnight Bedouin camp — stargazing.', accommodation: 'Memories Aicha Luxury Camp', meals: 'All meals' },
  { day: 'Days 8–10', title: 'Dead Sea & Aqaba', description: 'Day 8: Drive to Dead Sea. Float in the saltiest water on Earth. Day 9: Fly to Aqaba. Red Sea snorkelling. Day 10: Depart Aqaba.', accommodation: 'Kempinski Hotel Aqaba', meals: 'Breakfast daily' }],

  accommodation: 'Four Seasons Hotel Amman; Mövenpick Resort Petra; Memories Aicha Luxury Camp (Wadi Rum); Kempinski Hotel Aqaba.',
  included: ['All accommodation', 'All meals in Wadi Rum', 'Daily breakfast', 'Expert guide', 'Petra by Night', 'Jeep tour', 'Camel trek', 'All entrance fees', 'All transfers'],
  excluded: ['International flights to Amman', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Amman; private coach; domestic flight to Aqaba.',
  meals: 'All meals in Wadi Rum; breakfast daily elsewhere.',
  packing: ['Comfortable walking shoes', 'Modest clothing', 'Sunscreen', 'Hat', 'Camera', 'Swimwear for Dead Sea'],
  visa: 'Jordan visa on arrival or Jordan Pass (includes entry fee and Petra tickets).',
  weather: 'March–May and September–November: 20–28°C — ideal.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'How long does it take to walk through Petra?', answer: 'The main Petra circuit takes 4–6 hours. The Monastery adds another 2 hours. We recommend 2 full days to see Petra properly.' },
  { question: 'Is the Dead Sea really that salty?', answer: 'Yes — the Dead Sea is 10 times saltier than the ocean. You float effortlessly. The mineral-rich mud is excellent for skin.' }],

  seo: {
    title: 'Jordan Petra Wadi Rum Dead Sea Aqaba | Worldway × A&K',
    description: 'Jordan\'s extraordinary heritage — Petra, Wadi Rum, Dead Sea, and Aqaba with Worldway × A&K.',
    keywords: ['Jordan tour', 'Petra', 'Wadi Rum', 'Dead Sea', 'Aqaba', 'Nabataean', 'Jerash'],
    ogImage: "https://images.unsplash.com/photo-1720110640666-0f0986b676ef"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1586724237569-f3d0c1dee8c6?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['oman-muscat-wahiba-sands-nizwa-fjords-musandam', 'israel-jerusalem-tel-aviv-galilee-negev'],
  aiIndex: { tags: ['Jordan', 'Petra', 'Wadi Rum', 'Dead Sea', 'Aqaba', 'Nabataean', 'Jerash', 'cultural'], searchable: true }
},
{
  id: 357,
  slug: 'indonesia-bali-komodo-raja-ampat-borobudur',
  title: 'Indonesia: Bali, Komodo, Raja Ampat & Borobudur',
  region: 'Asia',
  country: 'Indonesia',
  cities: ['Bali', 'Komodo', 'Raja Ampat', 'Yogyakarta'],
  travelStyle: 'Adventure Journey',
  wayToTravel: 'Adventure Journeys',
  interests: ['Wildlife & Safari', 'Culture & Heritage', 'Nature'],
  months: ['April', 'May', 'June', 'July', 'August', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 14,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Moderate',
  price: 8500,
  priceLabel: 'From $8,500 pp',
  availability: 'Open',
  shortDescription: 'Indonesia\'s greatest journey — Bali\'s temples, Komodo dragons, Raja Ampat\'s world-class diving, and Borobudur\'s Buddhist stupa.',
  overview: 'Indonesia is the world\'s largest archipelago — 17,000 islands spanning 5,000 kilometres. Bali is the world\'s most famous tropical island. Komodo National Park is home to the world\'s largest lizard. Raja Ampat is the world\'s most biodiverse marine environment. Borobudur is the world\'s largest Buddhist monument.',
  highlights: [
  'Komodo dragons — the world\'s largest lizard',
  'Raja Ampat — world\'s most biodiverse diving',
  'Borobudur — UNESCO Buddhist stupa at sunrise',
  'Bali — Tanah Lot temple and rice terraces',
  'Prambanan — Hindu temple complex',
  'Manta rays — snorkelling in Komodo'],

  itinerary: ['Bali', 'Komodo', 'Raja Ampat', 'Yogyakarta'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Bali', description: 'Day 1: Arrive Bali. Ubud. Welcome dinner. Day 2: Tegalalang rice terraces, Tirta Empul temple. Day 3: Tanah Lot. Seminyak beach.', accommodation: 'Four Seasons Resort Bali at Sayan', meals: 'Breakfast daily' },
  { day: 'Days 4–6', title: 'Komodo', description: 'Day 4: Fly to Labuan Bajo. Komodo National Park. Day 5: Komodo dragon trek. Snorkelling with manta rays. Day 6: Pink Beach. Fly to Raja Ampat.', accommodation: 'Plataran Komodo', meals: 'Breakfast daily' },
  { day: 'Days 7–10', title: 'Raja Ampat', description: 'Day 7: Arrive Raja Ampat. Dive briefing. Day 8–9: Diving — world\'s most biodiverse reefs. Day 10: Snorkelling. Fly to Yogyakarta.', accommodation: 'Papua Paradise Eco Resort', meals: 'All meals' },
  { day: 'Days 11–14', title: 'Yogyakarta', description: 'Day 11: Arrive Yogyakarta. Kraton palace. Day 12: Borobudur at sunrise. Day 13: Prambanan Hindu temples. Day 14: Fly Bali. Depart.', accommodation: 'Amanjiwo', meals: 'Breakfast daily' }],

  accommodation: 'Four Seasons Resort Bali at Sayan; Plataran Komodo; Papua Paradise Eco Resort (Raja Ampat); Amanjiwo (Yogyakarta).',
  included: ['All accommodation', 'All meals at Raja Ampat', 'Daily breakfast', 'Expert guide', 'Diving equipment', 'All park fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Bali', 'Travel insurance', 'Gratuities', 'Personal expenses', 'Dive certification'],
  transport: 'International flight to Bali; domestic flights; private boat; private coach.',
  meals: 'All meals at Raja Ampat; breakfast daily elsewhere.',
  packing: ['Lightweight clothing', 'Swimwear', 'Dive certification card', 'Sunscreen (reef-safe)', 'Insect repellent', 'Camera with underwater housing', 'Modest clothing for temples'],
  visa: 'Indonesia visa on arrival for most nationalities (30 days).',
  weather: 'April–October: dry season — best for diving and Komodo.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Do I need to be a certified diver for Raja Ampat?', answer: 'Yes — Raja Ampat diving requires PADI Open Water certification. We can arrange a discover scuba course for non-divers, or snorkelling is an excellent alternative.' },
  { question: 'Are Komodo dragons dangerous?', answer: 'Komodo dragons are the world\'s largest lizard and can be dangerous. All treks are accompanied by armed park rangers who ensure safety.' }],

  seo: {
    title: 'Indonesia Bali Komodo Raja Ampat Borobudur | Worldway × A&K',
    description: 'Indonesia\'s greatest journey — Bali, Komodo dragons, Raja Ampat diving, and Borobudur with Worldway × A&K.',
    keywords: ['Indonesia tour', 'Bali', 'Komodo', 'Raja Ampat', 'Borobudur', 'diving', 'Komodo dragon'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1601f0f67-1772088132512.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['thailand-bangkok-chiang-mai-elephant-sanctuary-islands', 'vietnam-north-south-halong-hoi-an-mekong'],
  aiIndex: { tags: ['Indonesia', 'Bali', 'Komodo', 'Raja Ampat', 'Borobudur', 'diving', 'Komodo dragon', 'adventure'], searchable: true }
},
{
  id: 358,
  slug: 'scotland-highlands-islands-whisky-castles-loch-ness',
  title: 'Scotland: Highlands, Islands, Whisky & Castles',
  region: 'Europe',
  country: 'Scotland',
  cities: ['Edinburgh', 'Inverness', 'Isle of Skye', 'Orkney', 'St Andrews'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Adventure', 'Culinary'],
  months: ['May', 'June', 'July', 'August', 'September'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Moderate',
  price: 7200,
  priceLabel: 'From $7,200 pp',
  availability: 'Open',
  shortDescription: 'Scotland\'s wild beauty — Edinburgh\'s castle, Loch Ness, Isle of Skye\'s dramatic landscapes, Orkney\'s ancient stones, and single malt whisky distilleries.',
  overview: 'Scotland is one of Europe\'s most dramatic and romantic destinations — a land of ancient castles, misty lochs, dramatic Highland landscapes, and world-class whisky. Edinburgh is one of Europe\'s most beautiful capitals. The Isle of Skye is one of the world\'s most spectacular islands. Orkney\'s prehistoric monuments predate Stonehenge.',
  highlights: [
  'Edinburgh Castle — the crown jewels of Scotland',
  'Loch Ness — monster hunting and Urquhart Castle',
  'Isle of Skye — Old Man of Storr and Fairy Pools',
  'Orkney — Ring of Brodgar and Skara Brae',
  'Whisky distillery — single malt tasting',
  'Glencoe — Scotland\'s most dramatic glen'],

  itinerary: ['Edinburgh', 'Loch Ness', 'Isle of Skye', 'Orkney', 'St Andrews'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Edinburgh', description: 'Day 1: Arrive Edinburgh. Royal Mile. Welcome dinner. Day 2: Edinburgh Castle, Holyrood Palace. Day 3: Arthur\'s Seat hike. Drive north.', accommodation: 'The Balmoral Hotel', meals: 'Breakfast daily' },
  { day: 'Days 4–5', title: 'Loch Ness & Inverness', description: 'Day 4: Glencoe. Loch Ness — Urquhart Castle. Day 5: Inverness. Culloden Battlefield. Whisky distillery.', accommodation: 'Rocpool Reserve', meals: 'Breakfast daily' },
  { day: 'Days 6–7', title: 'Isle of Skye', description: 'Day 6: Drive to Skye. Old Man of Storr. Day 7: Fairy Pools. Dunvegan Castle. Eilean Donan Castle.', accommodation: 'Kinloch Lodge', meals: 'Breakfast daily' },
  { day: 'Days 8–9', title: 'Orkney', description: 'Day 8: Fly to Orkney. Ring of Brodgar. Day 9: Skara Brae — 5,000-year-old village. Maeshowe. Fly to Edinburgh.', accommodation: 'Foveran Hotel', meals: 'Breakfast daily' },
  { day: 'Days 10–12', title: 'St Andrews & Departure', description: 'Day 10: St Andrews — golf course and cathedral. Day 11: Whisky tasting masterclass. Day 12: Depart Edinburgh.', accommodation: 'Old Course Hotel', meals: 'Breakfast daily' }],

  accommodation: 'The Balmoral Hotel (Edinburgh); Rocpool Reserve (Inverness); Kinloch Lodge (Skye); Foveran Hotel (Orkney); Old Course Hotel (St Andrews).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Whisky tasting', 'All entrance fees', 'Domestic flight to Orkney', 'All transfers'],
  excluded: ['International flights to Edinburgh', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Edinburgh; private coach; domestic flight to Orkney.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Waterproof jacket', 'Warm layers', 'Hiking boots', 'Sunscreen', 'Camera', 'Midges repellent (essential in summer)'],
  visa: 'Scotland (UK) — EU/EEA visa-free for most. Others check requirements.',
  weather: 'May–September: 12–20°C — best for Highland travel. Midges active June–August.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What are midges?', answer: 'Midges are tiny biting insects that swarm in Scotland from June to August, especially in the Highlands. Midge repellent is essential. Windy days and sunshine keep them away.' },
  { question: 'Is there really a Loch Ness Monster?', answer: 'The Loch Ness Monster (Nessie) is Scotland\'s most famous legend. The loch is the UK\'s largest by volume — dark, deep, and mysterious. Our guides share the full story.' }],

  seo: {
    title: 'Scotland Highlands Islands Whisky Castles | Worldway × A&K',
    description: 'Scotland\'s wild beauty — Edinburgh, Loch Ness, Isle of Skye, Orkney, and whisky with Worldway × A&K.',
    keywords: ['Scotland tour', 'Highlands', 'Isle of Skye', 'Loch Ness', 'Orkney', 'whisky', 'castles'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1be08d502-1785060140120.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['ireland-wild-atlantic-way-ring-of-kerry-connemara', 'norway-fjords-lofoten-svalbard-northern-lights'],
  aiIndex: { tags: ['Scotland', 'Highlands', 'Isle of Skye', 'Loch Ness', 'Orkney', 'whisky', 'castles', 'cultural'], searchable: true }
},
{
  id: 359,
  slug: 'maldives-overwater-bungalow-diving-whale-sharks',
  title: 'Maldives: Overwater Bungalows, Diving & Whale Sharks',
  region: 'Asia',
  country: 'Maldives',
  cities: ['Malé', 'North Malé Atoll', 'South Malé Atoll', 'Baa Atoll'],
  travelStyle: 'Beach & Wellness',
  wayToTravel: 'Beach & Wellness',
  interests: ['Beach', 'Wellness', 'Wildlife & Safari'],
  months: ['November', 'December', 'January', 'February', 'March', 'April'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Private — 2 to 8 guests',
  activityLevel: 'Easy',
  price: 12500,
  priceLabel: 'From $12,500 pp',
  availability: 'Open',
  shortDescription: 'The Maldives — the world\'s most beautiful archipelago — overwater bungalows, whale shark snorkelling, manta rays, and pristine coral reefs.',
  overview: 'The Maldives is the world\'s most beautiful archipelago — 1,200 coral islands scattered across the Indian Ocean. The Maldives offers the world\'s finest overwater bungalow experience, world-class diving and snorkelling, and extraordinary marine wildlife. Baa Atoll is a UNESCO Biosphere Reserve and the world\'s best place to snorkel with whale sharks and manta rays.',
  highlights: [
  'Overwater bungalow — glass floor above the lagoon',
  'Whale shark snorkelling — Baa Atoll UNESCO reserve',
  'Manta ray snorkelling — Hanifaru Bay',
  'Diving — pristine coral reefs and hammerhead sharks',
  'Sunset dolphin cruise',
  'Spa — overwater treatment pavilion'],

  itinerary: ['Malé', 'North Malé Atoll', 'Baa Atoll'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Malé & Transfer', description: 'Day 1: Arrive Malé. Seaplane transfer to resort. Welcome dinner. Day 2: Snorkelling on the house reef. Sunset cruise.', accommodation: 'Gili Lankanfushi', meals: 'All meals' },
  { day: 'Days 3–6', title: 'North Malé Atoll', description: 'Day 3: Diving — coral gardens and reef sharks. Day 4: Dolphin cruise. Spa treatment. Day 5: Sandbank picnic. Day 6: Night diving.', accommodation: 'Gili Lankanfushi', meals: 'All meals' },
  { day: 'Days 7–10', title: 'Baa Atoll', description: 'Day 7: Seaplane to Baa Atoll. Day 8: Hanifaru Bay — whale shark and manta ray snorkelling. Day 9: Diving — hammerhead sharks. Day 10: Seaplane to Malé. Depart.', accommodation: 'Four Seasons Resort Maldives at Landaa Giraavaru', meals: 'All meals' }],

  accommodation: 'Gili Lankanfushi (North Malé Atoll); Four Seasons Resort Maldives at Landaa Giraavaru (Baa Atoll).',
  included: ['All accommodation', 'All meals', 'Expert marine biologist guide', 'Snorkelling equipment', 'Diving (2 dives per day)', 'Seaplane transfers', 'Dolphin cruise', 'Spa treatment'],
  excluded: ['International flights to Malé', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Malé; seaplane transfers.',
  meals: 'All meals throughout.',
  packing: ['Swimwear', 'Lightweight clothing', 'Sunscreen (reef-safe)', 'Dive certification card', 'Camera with underwater housing', 'Sunglasses'],
  visa: 'Maldives visa on arrival for all nationalities (30 days).',
  weather: 'November–April: dry season — calm seas and excellent visibility.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'When is the best time to see whale sharks?', answer: 'Whale sharks visit Hanifaru Bay in Baa Atoll from May to November — peak is June to October. Manta rays are present year-round.' },
  { question: 'Is the Maldives suitable for non-divers?', answer: 'Absolutely — the Maldives has exceptional snorkelling directly from the beach. The house reef at Gili Lankanfushi is one of the best in the Maldives.' }],

  seo: {
    title: 'Maldives Overwater Bungalows Diving Whale Sharks | Worldway × A&K',
    description: 'Maldives — overwater bungalows, whale shark snorkelling, and pristine coral reefs with Worldway × A&K.',
    keywords: ['Maldives tour', 'overwater bungalow', 'whale sharks', 'manta rays', 'diving', 'Baa Atoll'],
    ogImage: "https://images.unsplash.com/photo-1590133315939-7a7a886b2eff"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['seychelles-island-hopping-beaches-wildlife-mahe', 'fiji-island-hopping-yasawa-mamanuca'],
  aiIndex: { tags: ['Maldives', 'overwater bungalow', 'whale sharks', 'manta rays', 'diving', 'Baa Atoll', 'coral reefs'], searchable: true }
},
{
  id: 360,
  slug: 'ireland-wild-atlantic-way-ring-of-kerry-connemara',
  title: 'Ireland: Wild Atlantic Way, Ring of Kerry & Connemara',
  region: 'Europe',
  country: 'Ireland',
  cities: ['Dublin', 'Galway', 'Connemara', 'Ring of Kerry', 'Dingle'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Nature', 'Adventure'],
  months: ['April', 'May', 'June', 'July', 'August', 'September'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 6200,
  priceLabel: 'From $6,200 pp',
  availability: 'Open',
  shortDescription: 'Ireland\'s Wild Atlantic Way — Dublin\'s pubs, Connemara\'s bogs, Ring of Kerry\'s coastal drama, and Dingle\'s dolphins.',
  overview: 'Ireland is one of Europe\'s most enchanting destinations — a land of ancient castles, dramatic coastal cliffs, emerald green landscapes, and legendary hospitality. The Wild Atlantic Way is the world\'s longest defined coastal route. The Ring of Kerry is one of Europe\'s most scenic drives. Connemara\'s wild boglands and mountains are quintessentially Irish.',
  highlights: [
  'Cliffs of Moher — 214-metre Atlantic cliffs',
  'Ring of Kerry — Ireland\'s most scenic coastal drive',
  'Connemara — wild boglands and Kylemore Abbey',
  'Dingle Peninsula — Fungie the dolphin',
  'Dublin — Trinity College and Guinness Storehouse',
  'Traditional music session — County Clare'],

  itinerary: ['Dublin', 'Galway', 'Connemara', 'Ring of Kerry', 'Dingle'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Dublin', description: 'Day 1: Arrive Dublin. Temple Bar. Welcome dinner. Day 2: Trinity College, Book of Kells. Guinness Storehouse.', accommodation: 'The Merrion Hotel', meals: 'Breakfast daily' },
  { day: 'Days 3–4', title: 'Galway & Cliffs of Moher', description: 'Day 3: Drive to Galway. Aran Islands. Day 4: Cliffs of Moher. Traditional music session in Doolin.', accommodation: 'The g Hotel', meals: 'Breakfast daily' },
  { day: 'Days 5–6', title: 'Connemara', description: 'Day 5: Kylemore Abbey. Connemara National Park. Day 6: Croagh Patrick. Drive to Kerry.', accommodation: 'Ashford Castle', meals: 'Breakfast daily' },
  { day: 'Days 7–8', title: 'Ring of Kerry', description: 'Day 7: Ring of Kerry — Killarney, Ladies\' View, Moll\'s Gap. Day 8: Skellig Michael — UNESCO monastic island (seasonal).', accommodation: 'The Europe Hotel & Resort', meals: 'Breakfast daily' },
  { day: 'Days 9–10', title: 'Dingle', description: 'Day 9: Dingle Peninsula — Slea Head Drive. Fungie dolphin boat trip. Day 10: Fly Dublin. Depart.', accommodation: 'Dingle Skellig Hotel', meals: 'Breakfast daily' }],

  accommodation: 'The Merrion Hotel (Dublin); The g Hotel (Galway); Ashford Castle (Connemara); The Europe Hotel (Kerry); Dingle Skellig Hotel.',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Aran Islands ferry', 'Dolphin boat trip', 'All entrance fees', 'All transfers'],
  excluded: ['International flights to Dublin', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Dublin; private coach; ferry.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Waterproof jacket', 'Warm layers', 'Comfortable walking shoes', 'Camera', 'Sunscreen'],
  visa: 'Ireland — EU/EEA visa-free. UK nationals: no visa. Others check requirements.',
  weather: 'April–September: 12–20°C. Rain is possible year-round — pack waterproofs.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What is Ashford Castle?', answer: 'Ashford Castle is a 13th-century castle on the shores of Lough Corrib — one of Ireland\'s most iconic luxury hotels. It offers falconry, horse riding, and boat trips.' },
  { question: 'Can we visit Skellig Michael?', answer: 'Skellig Michael is a UNESCO World Heritage Site and Star Wars filming location. Boat trips are weather-dependent and must be booked in advance.' }],

  seo: {
    title: 'Ireland Wild Atlantic Way Ring of Kerry Connemara | Worldway × A&K',
    description: 'Ireland\'s Wild Atlantic Way — Cliffs of Moher, Ring of Kerry, and Connemara with Worldway × A&K.',
    keywords: ['Ireland tour', 'Wild Atlantic Way', 'Ring of Kerry', 'Connemara', 'Cliffs of Moher', 'Dublin'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1f4a64c24-1785752797283.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['scotland-highlands-islands-whisky-castles-loch-ness', 'norway-fjords-lofoten-svalbard-northern-lights'],
  aiIndex: { tags: ['Ireland', 'Wild Atlantic Way', 'Ring of Kerry', 'Connemara', 'Cliffs of Moher', 'Dublin', 'cultural'], searchable: true }
},
{
  id: 361,
  slug: 'turkey-istanbul-cappadocia-ephesus-turquoise-coast',
  title: 'Turkey: Istanbul, Cappadocia, Ephesus & Turquoise Coast',
  region: 'Europe',
  country: 'Turkey',
  cities: ['Istanbul', 'Cappadocia', 'Ephesus', 'Bodrum'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'History', 'Adventure'],
  months: ['April', 'May', 'June', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 6500,
  priceLabel: 'From $6,500 pp',
  availability: 'Open',
  shortDescription: 'Turkey\'s greatest journey — Istanbul\'s Hagia Sophia, Cappadocia\'s hot air balloons, Ephesus\'s Roman ruins, and the Turquoise Coast.',
  overview: 'Turkey is one of the world\'s most historically rich destinations — a country where East meets West, where Byzantine churches became Ottoman mosques, and where ancient Greek cities line the Aegean coast. Istanbul is one of the world\'s greatest cities. Cappadocia\'s fairy chimneys and cave hotels are unlike anywhere on Earth. Ephesus is the best-preserved Roman city in the world.',
  highlights: [
  'Istanbul — Hagia Sophia, Blue Mosque, and Grand Bazaar',
  'Cappadocia — hot air balloon at sunrise',
  'Ephesus — the best-preserved Roman city in the world',
  'Pamukkale — white calcium terraces and Roman Hierapolis',
  'Turquoise Coast — gulet cruise',
  'Turkish hammam — traditional bath experience'],

  itinerary: ['Istanbul', 'Cappadocia', 'Ephesus', 'Pamukkale', 'Bodrum'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Istanbul', description: 'Day 1: Arrive Istanbul. Bosphorus cruise. Welcome dinner. Day 2: Hagia Sophia, Blue Mosque, Topkapi Palace. Day 3: Grand Bazaar, Spice Market. Turkish hammam.', accommodation: 'Four Seasons Hotel Istanbul at Sultanahmet', meals: 'Breakfast daily' },
  { day: 'Days 4–6', title: 'Cappadocia', description: 'Day 4: Fly to Cappadocia. Göreme Open Air Museum. Day 5: Hot air balloon at sunrise. Underground city. Day 6: Ihlara Valley hike. Pottery workshop.', accommodation: 'Argos in Cappadocia', meals: 'Breakfast daily' },
  { day: 'Days 7–8', title: 'Ephesus & Pamukkale', description: 'Day 7: Fly to Izmir. Ephesus — Library of Celsus. Day 8: Pamukkale — white calcium terraces. Hierapolis Roman ruins.', accommodation: 'Hillside Su Hotel', meals: 'Breakfast daily' },
  { day: 'Days 9–12', title: 'Turquoise Coast', description: 'Day 9: Drive to Bodrum. Gulet cruise. Day 10: Sailing — coves and ruins. Day 11: Knidos — ancient Greek city. Day 12: Fly Istanbul. Depart.', accommodation: 'Mandarin Oriental Bodrum', meals: 'Breakfast daily' }],

  accommodation: 'Four Seasons Istanbul at Sultanahmet; Argos in Cappadocia; Hillside Su Hotel (Pamukkale); Mandarin Oriental Bodrum.',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Hot air balloon', 'Hammam', 'Gulet cruise', 'All entrance fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Istanbul', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Istanbul; domestic flights; private coach; gulet.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Smart casual clothing', 'Modest clothing for mosques', 'Comfortable walking shoes', 'Swimwear', 'Sunscreen', 'Camera'],
  visa: 'Turkey e-visa available online for most nationalities.',
  weather: 'April–June and September–October: 20–28°C — ideal.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is the Cappadocia balloon flight guaranteed?', answer: 'Balloon flights are weather-dependent. We book with the most reliable operators and reschedule if conditions are unsafe. Most guests fly successfully.' },
  { question: 'What is a gulet?', answer: 'A gulet is a traditional Turkish wooden sailing vessel. Our private gulet cruise along the Turquoise Coast stops at secluded coves, ancient ruins, and fishing villages.' }],

  seo: {
    title: 'Turkey Istanbul Cappadocia Ephesus Turquoise Coast | Worldway × A&K',
    description: 'Turkey\'s greatest journey — Istanbul, Cappadocia balloons, Ephesus, and Turquoise Coast with Worldway × A&K.',
    keywords: ['Turkey tour', 'Istanbul', 'Cappadocia', 'Ephesus', 'Turquoise Coast', 'hot air balloon'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1aa000fb4-1779508194556.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['greece-athens-santorini-mykonos-crete-rhodes', 'jordan-petra-wadi-rum-dead-sea-aqaba'],
  aiIndex: { tags: ['Turkey', 'Istanbul', 'Cappadocia', 'Ephesus', 'Turquoise Coast', 'hot air balloon', 'cultural'], searchable: true }
},
{
  id: 362,
  slug: 'canada-rockies-banff-jasper-yoho-private',
  title: 'Canada: Rockies — Banff, Jasper, Yoho & Icefields Parkway',
  region: 'North America',
  country: 'Canada',
  cities: ['Calgary', 'Banff', 'Lake Louise', 'Jasper', 'Vancouver'],
  travelStyle: 'Adventure Journey',
  wayToTravel: 'Adventure Journeys',
  interests: ['Adventure', 'Nature', 'Wildlife & Safari'],
  months: ['June', 'July', 'August', 'September'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Moderate',
  price: 9500,
  priceLabel: 'From $9,500 pp',
  availability: 'Open',
  shortDescription: 'Canada\'s Rocky Mountains — Banff\'s turquoise lakes, Icefields Parkway, Jasper\'s dark sky preserve, and grizzly bears.',
  overview: 'Canada\'s Rocky Mountains are one of the world\'s most spectacular mountain landscapes — a UNESCO World Heritage Site of turquoise glacial lakes, ancient icefields, and abundant wildlife. Banff is Canada\'s oldest national park. The Icefields Parkway is one of the world\'s most scenic drives. Jasper is one of the world\'s largest dark sky preserves.',
  highlights: [
  'Lake Louise — the world\'s most photographed lake',
  'Icefields Parkway — 230km of mountain scenery',
  'Columbia Icefield — glacier walk and Skywalk',
  'Jasper — grizzly bears and dark sky stargazing',
  'Moraine Lake — Valley of the Ten Peaks',
  'Banff gondola — 360° mountain views'],

  itinerary: ['Calgary', 'Banff', 'Lake Louise', 'Icefields Parkway', 'Jasper', 'Vancouver'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Calgary & Banff', description: 'Day 1: Arrive Calgary. Drive to Banff. Welcome dinner. Day 2: Banff gondola. Bow Falls. Cave and Basin.', accommodation: 'Fairmont Banff Springs', meals: 'Breakfast daily' },
  { day: 'Days 3–4', title: 'Lake Louise & Moraine Lake', description: 'Day 3: Lake Louise — canoe on the turquoise lake. Day 4: Moraine Lake — Valley of the Ten Peaks. Johnston Canyon.', accommodation: 'Fairmont Chateau Lake Louise', meals: 'Breakfast daily' },
  { day: 'Days 5–7', title: 'Icefields Parkway', description: 'Day 5: Drive Icefields Parkway — Peyto Lake, Bow Summit. Day 6: Columbia Icefield — glacier walk and Skywalk. Day 7: Sunwapta Falls. Arrive Jasper.', accommodation: 'Fairmont Jasper Park Lodge', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'Jasper', description: 'Day 8: Maligne Lake — Spirit Island. Day 9: Grizzly bear viewing. Dark sky stargazing. Day 10: Miette Hot Springs. Drive to Edmonton.', accommodation: 'Fairmont Jasper Park Lodge', meals: 'Breakfast daily' },
  { day: 'Days 11–12', title: 'Vancouver', description: 'Day 11: Fly to Vancouver. Stanley Park. Day 12: Granville Island. Depart.', accommodation: 'Fairmont Hotel Vancouver', meals: 'Breakfast daily' }],

  accommodation: 'Fairmont Banff Springs; Fairmont Chateau Lake Louise; Fairmont Jasper Park Lodge; Fairmont Hotel Vancouver.',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Columbia Icefield glacier walk', 'Grizzly bear viewing', 'All park fees', 'All transfers'],
  excluded: ['International flights to Calgary', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Calgary; private coach; domestic flight to Vancouver.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Warm layers', 'Waterproof jacket', 'Hiking boots', 'Sunscreen', 'Camera', 'Binoculars'],
  visa: 'Canada eTA required for most nationalities (online).',
  weather: 'June–September: 15–25°C — best for hiking and wildlife.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What wildlife can we see in the Rockies?', answer: 'Grizzly and black bears, elk, moose, bighorn sheep, mountain goats, wolves, and coyotes are all commonly seen. Early morning and evening are best.' },
  { question: 'Is Lake Louise as beautiful as the photos?', answer: 'Lake Louise exceeds all expectations — the turquoise glacial water against the Victoria Glacier is one of the world\'s most spectacular natural scenes.' }],

  seo: {
    title: 'Canada Rockies Banff Jasper Yoho Icefields Parkway | Worldway × A&K',
    description: 'Canada\'s Rocky Mountains — Banff, Lake Louise, Icefields Parkway, and Jasper with Worldway × A&K.',
    keywords: ['Canada Rockies tour', 'Banff', 'Jasper', 'Lake Louise', 'Icefields Parkway', 'grizzly bears'],
    ogImage: "https://images.unsplash.com/photo-1633688194449-1fa71f0d7859"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['alaska-wilderness-denali-kenai-glacier-bay', 'usa-national-parks-yellowstone-grand-canyon-zion'],
  aiIndex: { tags: ['Canada', 'Rockies', 'Banff', 'Jasper', 'Lake Louise', 'Icefields Parkway', 'grizzly bears', 'adventure'], searchable: true }
},
{
  id: 363,
  slug: 'zimbabwe-victoria-falls-hwange-mana-pools',
  title: 'Zimbabwe: Victoria Falls, Hwange & Mana Pools',
  region: 'Africa',
  country: 'Zimbabwe',
  cities: ['Victoria Falls', 'Hwange', 'Mana Pools'],
  travelStyle: 'Wildlife Journey',
  wayToTravel: 'Wildlife Journeys',
  interests: ['Wildlife & Safari', 'Adventure', 'Nature'],
  months: ['June', 'July', 'August', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 10 guests',
  activityLevel: 'Moderate',
  price: 11500,
  priceLabel: 'From $11,500 pp',
  availability: 'Open',
  shortDescription: 'Zimbabwe\'s finest — Victoria Falls\' thundering curtain, Hwange\'s elephant herds, and Mana Pools\' walking safaris with wild dogs.',
  overview: 'Zimbabwe is one of Africa\'s most rewarding safari destinations — a country of extraordinary wildlife, dramatic landscapes, and warm hospitality. Victoria Falls is one of the world\'s greatest natural wonders. Hwange National Park has the largest elephant population in Africa. Mana Pools is a UNESCO World Heritage Site and one of Africa\'s finest walking safari destinations.',
  highlights: [
  'Victoria Falls — the world\'s largest waterfall curtain',
  'Hwange — 40,000 elephants and 100 lion prides',
  'Mana Pools — walking safari with wild dogs',
  'Zambezi River — sunset canoe safari',
  'Bungee jumping from Victoria Falls Bridge',
  'Canoe safari — hippos and crocodiles'],

  itinerary: ['Victoria Falls', 'Hwange', 'Mana Pools'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Victoria Falls', description: 'Day 1: Arrive Victoria Falls. Welcome dinner. Day 2: Falls tour — both sides. Sunset Zambezi cruise. Day 3: Bungee jumping or white-water rafting. Fly to Hwange.', accommodation: 'Victoria Falls Hotel', meals: 'Breakfast daily' },
  { day: 'Days 4–6', title: 'Hwange', description: 'Day 4: Arrive Hwange. Afternoon game drive — elephant herds. Day 5: Full day game drives — lion, wild dog, sable antelope. Day 6: Night drive. Fly to Mana Pools.', accommodation: 'Linkwasha Camp', meals: 'All meals' },
  { day: 'Days 7–10', title: 'Mana Pools', description: 'Day 7: Arrive Mana Pools. Walking safari briefing. Day 8: Full day walking safari — wild dogs, elephant, lion. Day 9: Canoe safari — hippos and crocodiles. Day 10: Fly Harare. Depart.', accommodation: 'Ruckomechi Camp', meals: 'All meals' }],

  accommodation: 'Victoria Falls Hotel; Linkwasha Camp (Hwange); Ruckomechi Camp (Mana Pools).',
  included: ['All accommodation', 'All meals at camps', 'Daily breakfast', 'Expert guide', 'Walking safari', 'Canoe safari', 'All game drives', 'All park fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Victoria Falls', 'Travel insurance', 'Gratuities', 'Personal expenses', 'Adventure activities'],
  transport: 'International flight to Victoria Falls; light aircraft between camps; private 4WD.',
  meals: 'All meals at camps; breakfast daily elsewhere.',
  packing: ['Neutral safari clothing', 'Sturdy walking boots', 'Warm layers for early mornings', 'Binoculars', 'Camera', 'Sunscreen', 'Insect repellent'],
  visa: 'Zimbabwe visa on arrival or KAZA Univisa (covers Zambia too).',
  weather: 'June–October: dry season — best game viewing. Victoria Falls: most water April–June.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What makes Mana Pools special?', answer: 'Mana Pools is one of Africa\'s only national parks where walking safaris are permitted without a vehicle. The Zambezi floodplain attracts extraordinary concentrations of wildlife.' },
  { question: 'Is Victoria Falls better from Zimbabwe or Zambia?', answer: 'Zimbabwe offers the best views of the main falls. Zambia offers the best views of the Devil\'s Cataract and the Knife Edge Bridge. We visit both sides.' }],

  seo: {
    title: 'Zimbabwe Victoria Falls Hwange Mana Pools | Worldway × A&K',
    description: 'Zimbabwe\'s finest — Victoria Falls, Hwange elephants, and Mana Pools walking safari with Worldway × A&K.',
    keywords: ['Zimbabwe safari', 'Victoria Falls', 'Hwange', 'Mana Pools', 'walking safari', 'wild dogs'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_139d1dad2-1785000415320.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80',
  'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80'],

  relatedJourneys: ['zambia-south-luangwa-lower-zambezi-walking', 'botswana-okavango-delta-chobe-moremi-makgadikgadi'],
  aiIndex: { tags: ['Zimbabwe', 'Victoria Falls', 'Hwange', 'Mana Pools', 'walking safari', 'wild dogs', 'elephants'], searchable: true }
},
{
  id: 364,
  slug: 'nepal-everest-base-camp-kathmandu-pokhara',
  title: 'Nepal: Everest Base Camp, Kathmandu & Pokhara',
  region: 'Asia',
  country: 'Nepal',
  cities: ['Kathmandu', 'Lukla', 'Namche Bazaar', 'Everest Base Camp', 'Pokhara'],
  travelStyle: 'Adventure Journey',
  wayToTravel: 'Adventure Journeys',
  interests: ['Adventure', 'Culture & Heritage', 'Spiritual'],
  months: ['March', 'April', 'May', 'October', 'November'],
  years: ['2025', '2026', '2027'],
  days: 16,
  groupSize: 'Small Group — maximum 10 guests',
  activityLevel: 'Strenuous',
  price: 8500,
  priceLabel: 'From $8,500 pp',
  availability: 'Open',
  shortDescription: 'Nepal\'s ultimate adventure — trekking to Everest Base Camp at 5,364m, Kathmandu\'s UNESCO temples, and Pokhara\'s Annapurna views.',
  overview: 'Nepal is the world\'s greatest trekking destination — home to eight of the world\'s ten highest mountains. The Everest Base Camp trek is one of the world\'s most iconic adventures — a 12-day journey through Sherpa villages, Buddhist monasteries, and high-altitude glaciers to the foot of the world\'s highest mountain. Kathmandu\'s UNESCO World Heritage Sites are among Asia\'s finest.',
  highlights: [
  'Everest Base Camp — 5,364m at the foot of the world\'s highest mountain',
  'Kala Patthar — sunrise view of Everest summit',
  'Namche Bazaar — the Sherpa capital',
  'Tengboche Monastery — Buddhist prayers at 3,867m',
  'Kathmandu — Boudhanath stupa and Pashupatinath',
  'Pokhara — Annapurna reflections in Phewa Lake'],

  itinerary: ['Kathmandu', 'Lukla', 'Namche', 'Tengboche', 'Everest Base Camp', 'Pokhara'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Kathmandu', description: 'Day 1: Arrive Kathmandu. Welcome dinner. Day 2: Boudhanath, Pashupatinath, Swayambhunath. Trek briefing.', accommodation: 'Dwarika\'s Hotel', meals: 'Breakfast daily' },
  { day: 'Days 3–14', title: 'Everest Base Camp Trek', description: 'Day 3: Fly to Lukla. Trek to Phakding. Day 4: Namche Bazaar. Day 5: Acclimatisation. Day 6: Tengboche. Day 7: Dingboche. Day 8: Acclimatisation. Day 9: Lobuche. Day 10: Gorak Shep. Everest Base Camp. Day 11: Kala Patthar sunrise. Day 12: Descent to Namche. Day 13: Lukla. Day 14: Fly to Kathmandu.', accommodation: 'Tea houses and lodges', meals: 'All meals' },
  { day: 'Days 15–16', title: 'Pokhara', description: 'Day 15: Fly to Pokhara. Phewa Lake. Annapurna views. Day 16: Fly Kathmandu. Depart.', accommodation: 'Tiger Mountain Pokhara Lodge', meals: 'Breakfast daily' }],

  accommodation: 'Dwarika\'s Hotel (Kathmandu); tea houses on trek; Tiger Mountain Pokhara Lodge.',
  included: ['All accommodation', 'All meals on trek', 'Daily breakfast', 'Expert Sherpa guide', 'Porter', 'All permits', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Kathmandu', 'Travel insurance (mandatory)', 'Gratuities', 'Personal expenses', 'Altitude medication'],
  transport: 'International flight to Kathmandu; domestic flights to Lukla and Pokhara; trekking.',
  meals: 'All meals on trek; breakfast daily elsewhere.',
  packing: ['Trekking boots (broken in)', 'Warm down jacket', 'Thermal base layers', 'Trekking poles', 'Sleeping bag (-15°C)', 'Sunscreen', 'Altitude medication'],
  visa: 'Nepal visa on arrival or e-visa. Trekking permits required (included).',
  weather: 'March–May: spring — rhododendrons. October–November: autumn — clearest skies.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'How fit do I need to be for Everest Base Camp?', answer: 'You need good cardiovascular fitness and the ability to walk 5–7 hours per day for 12 days. No technical climbing is required. Regular hiking training for 3 months is recommended.' },
  { question: 'What is altitude sickness?', answer: 'Altitude sickness (AMS) can affect anyone above 3,000m. Symptoms include headache, nausea, and fatigue. We acclimatise carefully and carry emergency oxygen.' }],

  seo: {
    title: 'Nepal Everest Base Camp Kathmandu Pokhara | Worldway × A&K',
    description: 'Nepal\'s ultimate adventure — Everest Base Camp trek, Kathmandu temples, and Pokhara with Worldway × A&K.',
    keywords: ['Nepal tour', 'Everest Base Camp', 'trekking', 'Kathmandu', 'Pokhara', 'Himalayas'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_19c150f7a-1784044907091.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['bhutan-paro-thimphu-punakha-tigers-nest', 'tibet-lhasa-potala-namtso-everest-base-camp'],
  aiIndex: { tags: ['Nepal', 'Everest Base Camp', 'trekking', 'Kathmandu', 'Pokhara', 'Himalayas', 'adventure'], searchable: true }
},
{
  id: 365,
  slug: 'seychelles-island-hopping-mahe-praslin-la-digue',
  title: 'Seychelles: Island Hopping — Mahé, Praslin & La Digue',
  region: 'Africa',
  country: 'Seychelles',
  cities: ['Mahé', 'Praslin', 'La Digue', 'Silhouette'],
  travelStyle: 'Beach & Wellness',
  wayToTravel: 'Beach & Wellness',
  interests: ['Beach', 'Wildlife & Safari', 'Wellness'],
  months: ['April', 'May', 'October', 'November'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Private — 2 to 8 guests',
  activityLevel: 'Easy',
  price: 11500,
  priceLabel: 'From $11,500 pp',
  availability: 'Open',
  shortDescription: 'The Seychelles — the world\'s most beautiful islands — giant tortoises, Vallée de Mai\'s coco de mer palms, and Anse Source d\'Argent\'s pink granite boulders.',
  overview: 'The Seychelles is the world\'s most beautiful archipelago — 115 granite and coral islands scattered across the Indian Ocean. The beaches of La Digue and Praslin are consistently ranked among the world\'s finest. Vallée de Mai is a UNESCO World Heritage Site and the only place on Earth where the coco de mer palm grows wild. The Seychelles has the world\'s largest population of giant Aldabra tortoises.',
  highlights: [
  'Anse Source d\'Argent — the world\'s most photographed beach',
  'Vallée de Mai — UNESCO coco de mer forest',
  'Giant Aldabra tortoises — the world\'s largest',
  'Anse Lazio — Praslin\'s finest beach',
  'Snorkelling — pristine coral reefs',
  'Silhouette Island — nature reserve and luxury lodge'],

  itinerary: ['Mahé', 'Praslin', 'La Digue', 'Silhouette'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Mahé', description: 'Day 1: Arrive Mahé. Victoria market. Welcome dinner. Day 2: Morne Seychellois National Park hike. Beau Vallon beach.', accommodation: 'Four Seasons Resort Seychelles', meals: 'Breakfast daily' },
  { day: 'Days 3–5', title: 'Praslin', description: 'Day 3: Ferry to Praslin. Vallée de Mai — coco de mer. Day 4: Anse Lazio — snorkelling. Day 5: Curieuse Island — giant tortoises.', accommodation: 'Constance Lemuria', meals: 'Breakfast daily' },
  { day: 'Days 6–8', title: 'La Digue', description: 'Day 6: Ferry to La Digue. Anse Source d\'Argent. Day 7: Bicycle tour of the island. Day 8: Grand Anse and Petite Anse.', accommodation: 'Domaine de L\'Orangeraie', meals: 'Breakfast daily' },
  { day: 'Days 9–10', title: 'Silhouette Island', description: 'Day 9: Helicopter to Silhouette. Nature reserve. Day 10: Snorkelling. Helicopter to Mahé. Depart.', accommodation: 'Hilton Seychelles Labriz', meals: 'Breakfast daily' }],

  accommodation: 'Four Seasons Resort Seychelles (Mahé); Constance Lemuria (Praslin); Domaine de L\'Orangeraie (La Digue); Hilton Seychelles Labriz (Silhouette).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Vallée de Mai', 'Curieuse Island tour', 'Helicopter to Silhouette', 'All transfers'],
  excluded: ['International flights to Mahé', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Mahé; ferries; helicopter.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Swimwear', 'Lightweight clothing', 'Sunscreen (reef-safe)', 'Camera', 'Snorkelling gear (provided)', 'Comfortable walking shoes'],
  visa: 'Seychelles visa-free for all nationalities (30 days).',
  weather: 'April–May and October–November: calm seas — ideal. December–March: northwest monsoon.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What is the coco de mer?', answer: 'The coco de mer is the world\'s largest seed — up to 25kg. It grows only in Vallée de Mai on Praslin. The nut\'s suggestive shape makes it one of nature\'s most extraordinary curiosities.' },
  { question: 'Are the beaches as beautiful as the photos?', answer: 'The Seychelles beaches exceed all expectations. Anse Source d\'Argent\'s pink granite boulders and turquoise water are genuinely among the world\'s most beautiful.' }],

  seo: {
    title: 'Seychelles Island Hopping Mahé Praslin La Digue | Worldway × A&K',
    description: 'Seychelles island hopping — Vallée de Mai, giant tortoises, and Anse Source d\'Argent with Worldway × A&K.',
    keywords: ['Seychelles tour', 'Mahé', 'Praslin', 'La Digue', 'Vallée de Mai', 'coco de mer', 'beaches'],
    ogImage: "https://images.unsplash.com/photo-1665024318247-f3de7d0f7c28"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['maldives-overwater-bungalow-diving-whale-sharks', 'mauritius-luxury-beach-wildlife-chamarel'],
  aiIndex: { tags: ['Seychelles', 'Mahé', 'Praslin', 'La Digue', 'Vallée de Mai', 'coco de mer', 'beaches', 'giant tortoises'], searchable: true }
},
{
  id: 366,
  slug: 'zambia-south-luangwa-lower-zambezi-walking',
  title: 'Zambia: South Luangwa, Lower Zambezi & Walking Safaris',
  region: 'Africa',
  country: 'Zambia',
  cities: ['Lusaka', 'South Luangwa', 'Lower Zambezi', 'Victoria Falls'],
  travelStyle: 'Wildlife Journey',
  wayToTravel: 'Wildlife Journeys',
  interests: ['Wildlife & Safari', 'Adventure', 'Conservation'],
  months: ['June', 'July', 'August', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 8 guests',
  activityLevel: 'Moderate',
  price: 12500,
  priceLabel: 'From $12,500 pp',
  availability: 'Open',
  shortDescription: 'Zambia — the birthplace of the walking safari — South Luangwa\'s leopards, Lower Zambezi\'s canoe safaris, and Victoria Falls.',
  overview: 'Zambia is the birthplace of the walking safari — a country where the wilderness is experienced on foot, at eye level with the wildlife. South Luangwa is one of Africa\'s finest national parks — famous for its leopard density and night drives. The Lower Zambezi offers extraordinary canoe safaris among hippos and elephants. Victoria Falls is one of the world\'s greatest natural wonders.',
  highlights: [
  'Walking safari — tracking wildlife on foot with an armed guide',
  'South Luangwa — the highest leopard density in Africa',
  'Night drives — aardvark, civets, and honey badgers',
  'Lower Zambezi — canoe safari among hippos',
  'Victoria Falls — the Smoke that Thunders',
  'Kafue — wild dogs and cheetah'],

  itinerary: ['Lusaka', 'South Luangwa', 'Lower Zambezi', 'Victoria Falls'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Lusaka', description: 'Day 1: Arrive Lusaka. Welcome dinner. Day 2: Fly to South Luangwa.', accommodation: 'Latitude 15 Lusaka', meals: 'Breakfast daily' },
  { day: 'Days 3–6', title: 'South Luangwa', description: 'Day 3: Arrive South Luangwa. Afternoon game drive. Day 4: Walking safari — tracking leopard and lion. Day 5: Night drive — aardvark, civets. Day 6: Morning walk. Fly to Lower Zambezi.', accommodation: 'Chinzombo Camp', meals: 'All meals' },
  { day: 'Days 7–8', title: 'Lower Zambezi', description: 'Day 7: Arrive Lower Zambezi. Canoe safari — hippos and elephants. Day 8: Fishing for tiger fish. Game drive.', accommodation: 'Anabezi Luxury Tented Camp', meals: 'All meals' },
  { day: 'Days 9–10', title: 'Victoria Falls', description: 'Day 9: Fly to Victoria Falls. Falls tour. Sunset cruise. Day 10: Depart Victoria Falls.', accommodation: 'The Royal Livingstone Hotel', meals: 'Breakfast daily' }],

  accommodation: 'Latitude 15 Lusaka; Chinzombo Camp (South Luangwa); Anabezi Luxury Tented Camp (Lower Zambezi); The Royal Livingstone Hotel.',
  included: ['All accommodation', 'All meals at camps', 'Daily breakfast', 'Expert guide', 'Walking safaris', 'Canoe safari', 'All game drives', 'All park fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Lusaka', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Lusaka; light aircraft between camps; canoe; private 4WD.',
  meals: 'All meals at camps; breakfast daily elsewhere.',
  packing: ['Neutral safari clothing', 'Sturdy walking boots', 'Warm layers', 'Binoculars', 'Camera', 'Sunscreen', 'Insect repellent'],
  visa: 'Zambia visa on arrival or KAZA Univisa.',
  weather: 'June–October: dry season — best game viewing and walking conditions.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is a walking safari safe?', answer: 'Walking safaris are led by highly trained, armed professional guides. The experience is exhilarating and safe. You learn to read animal behaviour and tracks.' },
  { question: 'What is a tiger fish?', answer: 'The tiger fish is one of Africa\'s most prized sport fish — a fierce, fast predator with razor-sharp teeth. Fishing in the Lower Zambezi is world-class.' }],

  seo: {
    title: 'Zambia South Luangwa Lower Zambezi Walking Safari | Worldway × A&K',
    description: 'Zambia — walking safaris, South Luangwa leopards, Lower Zambezi canoes, and Victoria Falls with Worldway × A&K.',
    keywords: ['Zambia safari', 'South Luangwa', 'Lower Zambezi', 'walking safari', 'Victoria Falls', 'leopards'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_13fc90b2f-1784826074108.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80',
  'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80'],

  relatedJourneys: ['zimbabwe-victoria-falls-hwange-mana-pools', 'botswana-okavango-delta-chobe-moremi-makgadikgadi'],
  aiIndex: { tags: ['Zambia', 'South Luangwa', 'Lower Zambezi', 'walking safari', 'Victoria Falls', 'leopards', 'canoe'], searchable: true }
},
{
  id: 367,
  slug: 'croatia-dalmatian-coast-dubrovnik-split-hvar',
  title: 'Croatia: Dalmatian Coast — Dubrovnik, Split, Hvar & Korčula',
  region: 'Europe',
  country: 'Croatia',
  cities: ['Dubrovnik', 'Split', 'Hvar', 'Korčula', 'Plitvice'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Nature', 'Culinary'],
  months: ['May', 'June', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 6500,
  priceLabel: 'From $6,500 pp',
  availability: 'Open',
  shortDescription: 'Croatia\'s Dalmatian Coast — Dubrovnik\'s Game of Thrones walls, Split\'s Diocletian\'s Palace, Hvar\'s lavender fields, and Plitvice\'s turquoise lakes.',
  overview: 'Croatia\'s Dalmatian Coast is one of Europe\'s most beautiful coastlines — a string of UNESCO World Heritage Sites, medieval walled cities, and crystal-clear Adriatic islands. Dubrovnik is the Pearl of the Adriatic. Split\'s Diocletian\'s Palace is one of the world\'s best-preserved Roman monuments. Hvar is Croatia\'s most glamorous island.',
  highlights: [
  'Dubrovnik — Game of Thrones city walls',
  'Split — Diocletian\'s Palace UNESCO site',
  'Hvar — lavender fields and Venetian architecture',
  'Korčula — birthplace of Marco Polo',
  'Plitvice Lakes — UNESCO turquoise waterfalls',
  'Sailing the Adriatic — island hopping by boat'],

  itinerary: ['Dubrovnik', 'Hvar', 'Korčula', 'Split', 'Plitvice'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Dubrovnik', description: 'Day 1: Arrive Dubrovnik. Old Town. Welcome dinner. Day 2: City walls walk. Game of Thrones locations. Day 3: Elaphiti Islands boat trip.', accommodation: 'Hotel Excelsior Dubrovnik', meals: 'Breakfast daily' },
  { day: 'Days 4–5', title: 'Hvar & Korčula', description: 'Day 4: Ferry to Hvar. Lavender fields. Venetian loggia. Day 5: Ferry to Korčula. Marco Polo\'s birthplace.', accommodation: 'Amfora Grand Beach Resort', meals: 'Breakfast daily' },
  { day: 'Days 6–7', title: 'Split', description: 'Day 6: Ferry to Split. Diocletian\'s Palace. Day 7: Trogir UNESCO town. Krka waterfalls.', accommodation: 'Radisson Blu Resort & Spa Split', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'Plitvice & Zagreb', description: 'Day 8: Drive to Plitvice Lakes. Turquoise waterfalls. Day 9: Zagreb — Upper Town. Day 10: Fly home.', accommodation: 'Hotel Jezero Plitvice', meals: 'Breakfast daily' }],

  accommodation: 'Hotel Excelsior Dubrovnik; Amfora Grand Beach Resort (Hvar); Radisson Blu Split; Hotel Jezero Plitvice.',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'All entrance fees', 'Elaphiti Islands boat trip', 'All ferries', 'All transfers'],
  excluded: ['International flights to Dubrovnik', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Dubrovnik; ferries; private coach.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Lightweight summer clothing', 'Comfortable walking shoes', 'Swimwear', 'Sunscreen', 'Camera', 'Light jacket for evenings'],
  visa: 'Croatia is EU/Schengen — EU/EEA visa-free. Others check requirements.',
  weather: 'May–June and September–October: 22–28°C — ideal. July–August: very hot and crowded.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is Dubrovnik too crowded?', answer: 'Dubrovnik can be very crowded in July–August. We recommend May–June or September–October for a more relaxed experience. Early morning visits to the walls avoid the crowds.' },
  { question: 'What is Plitvice Lakes?', answer: 'Plitvice Lakes is a UNESCO World Heritage Site of 16 terraced lakes connected by waterfalls. The turquoise water is extraordinary — one of Europe\'s most beautiful natural sites.' }],

  seo: {
    title: 'Croatia Dalmatian Coast Dubrovnik Split Hvar | Worldway × A&K',
    description: 'Croatia\'s Dalmatian Coast — Dubrovnik, Split, Hvar, and Plitvice Lakes with Worldway × A&K.',
    keywords: ['Croatia tour', 'Dubrovnik', 'Split', 'Hvar', 'Dalmatian Coast', 'Plitvice', 'Adriatic'],
    ogImage: "https://images.unsplash.com/photo-1554387225-f9ce8feb626a"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['greece-athens-santorini-mykonos-crete-rhodes', 'italy-rome-florence-venice-amalfi-sicily'],
  aiIndex: { tags: ['Croatia', 'Dubrovnik', 'Split', 'Hvar', 'Dalmatian Coast', 'Plitvice', 'Adriatic', 'cultural'], searchable: true }
},
{
  id: 368,
  slug: 'usa-national-parks-yellowstone-grand-canyon-zion',
  title: 'USA: National Parks — Yellowstone, Grand Canyon, Zion & Bryce',
  region: 'North America',
  country: 'USA',
  cities: ['Salt Lake City', 'Yellowstone', 'Grand Teton', 'Zion', 'Bryce Canyon', 'Grand Canyon'],
  travelStyle: 'Adventure Journey',
  wayToTravel: 'Adventure Journeys',
  interests: ['Adventure', 'Nature', 'Wildlife & Safari'],
  months: ['May', 'June', 'July', 'August', 'September'],
  years: ['2025', '2026', '2027'],
  days: 14,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Moderate',
  price: 8500,
  priceLabel: 'From $8,500 pp',
  availability: 'Open',
  shortDescription: 'America\'s greatest national parks — Yellowstone\'s geysers and bison, Grand Teton\'s peaks, Zion\'s slot canyons, Bryce\'s hoodoos, and the Grand Canyon.',
  overview: 'America\'s national parks are among the world\'s greatest natural treasures. Yellowstone is the world\'s first national park — a supervolcano of geysers, hot springs, and abundant wildlife. The Grand Canyon is one of the world\'s most awe-inspiring landscapes. Zion\'s slot canyons and Bryce\'s hoodoos are unlike anywhere else on Earth.',
  highlights: [
  'Yellowstone — Old Faithful geyser and bison herds',
  'Grand Teton — mirror reflections in Jenny Lake',
  'Zion — Angels Landing hike and The Narrows',
  'Bryce Canyon — hoodoos at sunrise',
  'Grand Canyon — South Rim at sunset',
  'Grizzly bears and wolves in Yellowstone'],

  itinerary: ['Salt Lake City', 'Yellowstone', 'Grand Teton', 'Zion', 'Bryce Canyon', 'Grand Canyon'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Salt Lake City', description: 'Day 1: Arrive Salt Lake City. Temple Square. Welcome dinner. Day 2: Drive to Yellowstone.', accommodation: 'Grand America Hotel', meals: 'Breakfast daily' },
  { day: 'Days 3–5', title: 'Yellowstone', description: 'Day 3: Old Faithful, Grand Prismatic Spring. Day 4: Lamar Valley — bison, wolves, grizzly bears. Day 5: Mammoth Hot Springs. Drive to Grand Teton.', accommodation: 'Old Faithful Inn', meals: 'Breakfast daily' },
  { day: 'Days 6–7', title: 'Grand Teton', description: 'Day 6: Jenny Lake — mirror reflections. Day 7: Snake River float trip. Drive to Zion.', accommodation: 'Amangani', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'Zion & Bryce Canyon', description: 'Day 8: Arrive Zion. Angels Landing hike. Day 9: The Narrows — wading through slot canyon. Day 10: Bryce Canyon — hoodoos at sunrise.', accommodation: 'Zion Lodge', meals: 'Breakfast daily' },
  { day: 'Days 11–14', title: 'Grand Canyon', description: 'Day 11: Drive to Grand Canyon. South Rim sunset. Day 12: Rim Trail. Helicopter flight. Day 13: Bright Angel Trail hike. Day 14: Fly Las Vegas. Depart.', accommodation: 'El Tovar Hotel', meals: 'Breakfast daily' }],

  accommodation: 'Grand America Hotel (SLC); Old Faithful Inn (Yellowstone); Amangani (Grand Teton); Zion Lodge; El Tovar Hotel (Grand Canyon).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Grand Canyon helicopter', 'Snake River float', 'All park fees', 'All transfers'],
  excluded: ['International flights to Salt Lake City', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Salt Lake City; private coach; helicopter.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Hiking boots', 'Waterproof jacket', 'Warm layers', 'Sunscreen', 'Camera', 'Binoculars', 'Water bottle'],
  visa: 'US visa or ESTA required for most nationalities.',
  weather: 'May–September: 20–35°C in canyon country. Yellowstone: 15–25°C in summer.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is Angels Landing hike difficult?', answer: 'Angels Landing is a strenuous 8km hike with 454m elevation gain. The final section involves chains on exposed rock. It is not suitable for those with a fear of heights.' },
  { question: 'What is the best time to see wolves in Yellowstone?', answer: 'Wolves are most visible in winter (November–March) in Lamar Valley. Summer offers excellent wildlife viewing with longer daylight hours.' }],

  seo: {
    title: 'USA National Parks Yellowstone Grand Canyon Zion Bryce | Worldway × A&K',
    description: 'America\'s greatest national parks — Yellowstone, Grand Canyon, Zion, and Bryce Canyon with Worldway × A&K.',
    keywords: ['USA national parks tour', 'Yellowstone', 'Grand Canyon', 'Zion', 'Bryce Canyon', 'Grand Teton'],
    ogImage: "https://images.unsplash.com/photo-1719856980495-539e7e3d7c5d"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['alaska-wilderness-denali-kenai-glacier-bay', 'canada-rockies-banff-jasper-yoho-private'],
  aiIndex: { tags: ['USA', 'national parks', 'Yellowstone', 'Grand Canyon', 'Zion', 'Bryce Canyon', 'adventure'], searchable: true }
},
{
  id: 369,
  slug: 'south-korea-seoul-jeju-gyeongju-dmz',
  title: 'South Korea: Seoul, Jeju, Gyeongju & DMZ',
  region: 'Asia',
  country: 'South Korea',
  cities: ['Seoul', 'Gyeongju', 'Jeju Island', 'DMZ'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Culinary', 'History'],
  months: ['March', 'April', 'May', 'September', 'October', 'November'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 5800,
  priceLabel: 'From $5,800 pp',
  availability: 'Open',
  shortDescription: 'South Korea\'s extraordinary journey — Seoul\'s K-culture, Gyeongju\'s Silla kingdom, Jeju\'s volcanic island, and the DMZ.',
  overview: 'South Korea is one of Asia\'s most dynamic and fascinating destinations — a country that has transformed from war-torn poverty to global cultural powerhouse in just 70 years. Seoul is one of the world\'s most vibrant cities. Gyeongju is the ancient capital of the Silla kingdom. Jeju Island is a UNESCO World Heritage Site of volcanic landscapes. The DMZ is one of the world\'s most tense borders.',
  highlights: [
  'Seoul — Gyeongbokgung Palace and Bukchon Hanok Village',
  'DMZ — the world\'s most heavily fortified border',
  'Gyeongju — Silla kingdom tumuli and Bulguksa temple',
  'Jeju Island — Hallasan volcano and lava tubes',
  'Korean cooking class — bibimbap and kimchi',
  'K-pop experience — SM Entertainment tour'],

  itinerary: ['Seoul', 'DMZ', 'Gyeongju', 'Jeju'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Seoul', description: 'Day 1: Arrive Seoul. Myeongdong. Welcome dinner. Day 2: Gyeongbokgung Palace, Bukchon Hanok Village. Day 3: Insadong, Changdeokgung Secret Garden.', accommodation: 'The Shilla Seoul', meals: 'Breakfast daily' },
  { day: 'Days 4–5', title: 'DMZ & Gyeongju', description: 'Day 4: DMZ tour — Joint Security Area. Day 5: Train to Gyeongju. Bulguksa temple, Seokguram grotto.', accommodation: 'Hilton Gyeongju', meals: 'Breakfast daily' },
  { day: 'Days 6–7', title: 'Gyeongju', description: 'Day 6: Tumuli Park — Silla royal tombs. Anapji Pond. Day 7: Fly to Jeju.', accommodation: 'Hilton Gyeongju', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'Jeju Island', description: 'Day 8: Arrive Jeju. Hallasan volcano hike. Day 9: Manjanggul lava tube. Seongsan Ilchulbong sunrise peak. Day 10: Fly Seoul. Depart.', accommodation: 'Lotte Hotel Jeju', meals: 'Breakfast daily' }],

  accommodation: 'The Shilla Seoul; Hilton Gyeongju; Lotte Hotel Jeju.',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'DMZ tour', 'Cooking class', 'All entrance fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Seoul', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Seoul; KTX high-speed train; domestic flight to Jeju; private coach.',
  meals: 'Daily breakfast; cooking class lunch.',
  packing: ['Smart casual clothing', 'Comfortable walking shoes', 'Layers for variable weather', 'Camera', 'Sunscreen'],
  visa: 'South Korea visa-free for most nationalities (90 days).',
  weather: 'March–May: cherry blossoms. September–November: autumn foliage.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is the DMZ tour safe?', answer: 'The DMZ tour is safe and well-organised. Visitors must follow strict rules and dress codes. The Joint Security Area (JSA) offers a unique glimpse into one of the world\'s most tense borders.' },
  { question: 'What is the best time for cherry blossoms in Seoul?', answer: 'Cherry blossoms typically bloom in late March to early April. Yeouido Park and Gyeongbokgung Palace are the most spectacular locations.' }],

  seo: {
    title: 'South Korea Seoul Jeju Gyeongju DMZ | Worldway × A&K',
    description: 'South Korea — Seoul, DMZ, Gyeongju Silla kingdom, and Jeju Island with Worldway × A&K.',
    keywords: ['South Korea tour', 'Seoul', 'Jeju', 'Gyeongju', 'DMZ', 'K-culture', 'Silla'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab16e584-1785755486310.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1517154421773-0529f29ea451?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['japan-tokyo-kyoto-hiroshima-hakone-nara', 'china-silk-road-beijing-xian-guilin-shanghai'],
  aiIndex: { tags: ['South Korea', 'Seoul', 'Jeju', 'Gyeongju', 'DMZ', 'K-culture', 'Silla', 'cultural'], searchable: true }
},
{
  id: 370,
  slug: 'ethiopia-lalibela-simien-mountains-omo-valley',
  title: 'Ethiopia: Lalibela, Simien Mountains & Omo Valley',
  region: 'Africa',
  country: 'Ethiopia',
  cities: ['Addis Ababa', 'Lalibela', 'Simien Mountains', 'Omo Valley'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Adventure', 'Wildlife & Safari'],
  months: ['October', 'November', 'December', 'January', 'February', 'March'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Small Group — maximum 10 guests',
  activityLevel: 'Moderate',
  price: 7200,
  priceLabel: 'From $7,200 pp',
  availability: 'Open',
  shortDescription: 'Ethiopia\'s extraordinary heritage — Lalibela\'s rock-hewn churches, Simien Mountains\' gelada baboons, and the Omo Valley\'s tribal cultures.',
  overview: 'Ethiopia is one of Africa\'s most extraordinary destinations — the cradle of humanity, the birthplace of coffee, and home to some of the world\'s most ancient Christian traditions. Lalibela\'s rock-hewn churches are one of the world\'s greatest architectural achievements. The Simien Mountains are a UNESCO World Heritage Site of dramatic escarpments and endemic wildlife. The Omo Valley is home to some of the world\'s most fascinating tribal cultures.',
  highlights: [
  'Lalibela — UNESCO rock-hewn churches carved from solid rock',
  'Simien Mountains — gelada baboons and Ethiopian wolves',
  'Omo Valley — Mursi, Hamar, and Karo tribal cultures',
  'Addis Ababa — National Museum and Lucy the hominid',
  'Axum — ancient obelisks and Ark of the Covenant',
  'Danakil Depression — the world\'s hottest place'],

  itinerary: ['Addis Ababa', 'Lalibela', 'Simien Mountains', 'Omo Valley'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Addis Ababa', description: 'Day 1: Arrive Addis. National Museum — Lucy. Welcome dinner. Day 2: Ethnological Museum. Merkato. Fly to Lalibela.', accommodation: 'Sheraton Addis', meals: 'Breakfast daily' },
  { day: 'Days 3–5', title: 'Lalibela', description: 'Day 3: Northern cluster — Bete Medhane Alem. Day 4: Southern cluster — Bete Giyorgis (St. George). Day 5: Yimrehane Krestos cave church. Fly to Gondar.', accommodation: 'Maribela Hotel', meals: 'Breakfast daily' },
  { day: 'Days 6–7', title: 'Simien Mountains', description: 'Day 6: Gondar — Fasilides Castles. Drive to Simien. Day 7: Gelada baboon trekking. Ethiopian wolf (if lucky).', accommodation: 'Simien Lodge', meals: 'All meals' },
  { day: 'Days 8–12', title: 'Omo Valley', description: 'Day 8: Fly to Jinka. Mursi tribe — lip plates. Day 9: Hamar tribe — bull jumping ceremony. Day 10: Karo tribe — body painting. Day 11: Arbore tribe. Day 12: Fly Addis. Depart.', accommodation: 'Eco Omo Lodge', meals: 'All meals' }],

  accommodation: 'Sheraton Addis; Maribela Hotel (Lalibela); Simien Lodge; Eco Omo Lodge (Omo Valley).',
  included: ['All accommodation', 'All meals at lodges', 'Daily breakfast', 'Expert guide', 'All entrance fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Addis Ababa', 'Travel insurance', 'Gratuities', 'Personal expenses', 'Tribal photography fees'],
  transport: 'International flight to Addis Ababa; domestic flights; private 4WD.',
  meals: 'All meals at lodges; breakfast daily elsewhere.',
  packing: ['Lightweight clothing', 'Warm layers for Simien Mountains', 'Hiking boots', 'Sunscreen', 'Insect repellent', 'Camera'],
  visa: 'Ethiopia e-visa available online for most nationalities.',
  weather: 'October–March: dry season — 20–30°C. Simien Mountains: cooler at altitude.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is the Omo Valley culturally sensitive?', answer: 'The Omo Valley tribes are proud of their traditions and welcome respectful visitors. Photography fees are paid directly to community members. Our guides ensure ethical interactions.' },
  { question: 'What is a gelada baboon?', answer: 'The gelada is a unique primate found only in the Ethiopian Highlands — the world\'s only grass-eating primate. Simien Mountains has the world\'s largest population.' }],

  seo: {
    title: 'Ethiopia Lalibela Simien Mountains Omo Valley | Worldway × A&K',
    description: 'Ethiopia\'s extraordinary heritage — Lalibela churches, Simien Mountains, and Omo Valley tribes with Worldway × A&K.',
    keywords: ['Ethiopia tour', 'Lalibela', 'Simien Mountains', 'Omo Valley', 'gelada baboons', 'rock churches'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1a19c5b47-1778566385869.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80',
  'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80'],

  relatedJourneys: ['kenya-masai-mara-amboseli-laikipia-private', 'rwanda-gorilla-trekking-volcanoes-nyungwe-akagera'],
  aiIndex: { tags: ['Ethiopia', 'Lalibela', 'Simien Mountains', 'Omo Valley', 'gelada baboons', 'rock churches', 'tribal'], searchable: true }
},
{
  id: 371,
  slug: 'mauritius-luxury-beach-wildlife-chamarel',
  title: 'Mauritius: Luxury Beach, Wildlife & Chamarel',
  region: 'Africa',
  country: 'Mauritius',
  cities: ['Port Louis', 'Grand Baie', 'Chamarel', 'Île aux Cerfs'],
  travelStyle: 'Beach & Wellness',
  wayToTravel: 'Beach & Wellness',
  interests: ['Beach', 'Wellness', 'Nature'],
  months: ['May', 'June', 'July', 'August', 'September', 'October', 'November'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Private — 2 to 8 guests',
  activityLevel: 'Easy',
  price: 8500,
  priceLabel: 'From $8,500 pp',
  availability: 'Open',
  shortDescription: 'Mauritius — the pearl of the Indian Ocean — turquoise lagoons, Chamarel\'s seven-coloured earth, Black River Gorges, and world-class spa resorts.',
  overview: 'Mauritius is one of the Indian Ocean\'s most beautiful islands — a volcanic island of turquoise lagoons, lush mountains, and extraordinary cultural diversity. Mauritius has some of the world\'s finest luxury beach resorts. Chamarel\'s seven-coloured earth is one of the world\'s most extraordinary geological phenomena. Black River Gorges National Park protects the island\'s endemic wildlife.',
  highlights: [
  'Turquoise lagoons — snorkelling with sea turtles',
  'Chamarel — seven-coloured earth and Chamarel waterfall',
  'Black River Gorges — endemic Mauritian wildlife',
  'Île aux Cerfs — pristine island beach',
  'Underwater waterfall — optical illusion from helicopter',
  'Spa — world-class Mauritian wellness'],

  itinerary: ['Port Louis', 'Grand Baie', 'Chamarel', 'Île aux Cerfs'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Port Louis & Grand Baie', description: 'Day 1: Arrive Mauritius. Welcome dinner. Day 2: Port Louis — Central Market, Blue Penny Museum. Drive to Grand Baie.', accommodation: 'One&Only Le Saint Géran', meals: 'Breakfast daily' },
  { day: 'Days 3–5', title: 'North Coast', description: 'Day 3: Snorkelling — sea turtles and tropical fish. Day 4: Catamaran cruise — Île aux Cerfs. Day 5: Helicopter flight — underwater waterfall optical illusion.', accommodation: 'One&Only Le Saint Géran', meals: 'Breakfast daily' },
  { day: 'Days 6–7', title: 'Chamarel & Black River', description: 'Day 6: Chamarel — seven-coloured earth, waterfall, rum distillery. Day 7: Black River Gorges — endemic birds and monkeys.', accommodation: 'Lux* Grand Gaube', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'South Coast', description: 'Day 8: Rochester Falls. Mahébourg historical village. Day 9: Spa day — Mauritian treatments. Day 10: Depart.', accommodation: 'Shangri-La Le Touessrok', meals: 'Breakfast daily' }],

  accommodation: 'One&Only Le Saint Géran (Grand Baie); Lux* Grand Gaube; Shangri-La Le Touessrok (South Coast).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'Catamaran cruise', 'Helicopter flight', 'Snorkelling equipment', 'All transfers'],
  excluded: ['International flights to Mauritius', 'Travel insurance', 'Gratuities', 'Personal expenses', 'Spa treatments'],
  transport: 'International flight to Mauritius; private coach; helicopter; catamaran.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Swimwear', 'Lightweight clothing', 'Sunscreen (reef-safe)', 'Camera', 'Snorkelling gear (provided)', 'Smart casual for evenings'],
  visa: 'Mauritius visa-free for most nationalities (90 days).',
  weather: 'May–November: dry season — 20–28°C. December–April: hot and humid.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What is the underwater waterfall?', answer: 'The underwater waterfall is an optical illusion created by sand and silt flowing off the continental shelf. It is best seen from a helicopter or drone.' },
  { question: 'What is the seven-coloured earth?', answer: 'Chamarel\'s seven-coloured earth is a geological phenomenon where volcanic soil has cooled at different rates, creating distinct bands of red, brown, violet, green, blue, purple, and yellow.' }],

  seo: {
    title: 'Mauritius Luxury Beach Wildlife Chamarel | Worldway × A&K',
    description: 'Mauritius — turquoise lagoons, Chamarel seven-coloured earth, and world-class resorts with Worldway × A&K.',
    keywords: ['Mauritius tour', 'luxury beach', 'Chamarel', 'seven-coloured earth', 'Indian Ocean', 'snorkelling'],
    ogImage: "https://images.unsplash.com/photo-1573616202320-fd910e2ce909"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['seychelles-island-hopping-mahe-praslin-la-digue', 'maldives-overwater-bungalow-diving-whale-sharks'],
  aiIndex: { tags: ['Mauritius', 'luxury beach', 'Chamarel', 'seven-coloured earth', 'Indian Ocean', 'snorkelling', 'wellness'], searchable: true }
}];